(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[238],{

/***/ 8718:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[handle]",
      function () {
        return __webpack_require__(7734);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Product; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ../node_modules/react-intersection-observer/dist/index.mjs
var react_intersection_observer_dist = __webpack_require__(8687);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(1529);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(3218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/hooks/index.js + 49 modules
var hooks = __webpack_require__(988);
// EXTERNAL MODULE: ./src/snippets/index.js + 287 modules
var snippets = __webpack_require__(8169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
// EXTERNAL MODULE: ./src/utilities/index.js + 3 modules
var utilities = __webpack_require__(2011);
// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(6471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValues/ProductColorOptionValue/ColorOptionIcon.jsx




function ColorOptionIcon(param) {
    var isLoading = param.isLoading, disabled = param.disabled, isUnavailable = param.isUnavailable, isSelected = param.isSelected, swatch = param.swatch, value = param.value, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, isAllOutOfStock = param.isAllOutOfStock;
    var ref;
    var isLightColor = (0,react.useMemo)(function() {
        return (0,utilities/* isLightHexColor */.Pd)(swatch === null || swatch === void 0 ? void 0 : swatch.color);
    }, [
        swatch === null || swatch === void 0 ? void 0 : swatch.color
    ]);
    var crossedOutClass = "after:h-px after:w-[150%] after:rotate-[135deg] after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 overflow-hidden ".concat(isLightColor ? "after:bg-black" : "after:bg-white");
    var validClass = !disabled ? "md:group-hover/color:border-text" : "cursor-not-allowed";
    var selectedClass = isSelected ? "border-text" : "";
    var unavailableClass = isUnavailable ? crossedOutClass : "";
    var availibilityClass = isLoading ? "" : isAllOutOfStock ? crossedOutClass : !enabledSoldOutColorSwatch ? "" : unavailableClass;
    var primaryCutoffPercentage = (swatch === null || swatch === void 0 ? void 0 : swatch.cutoffPercentage) || 50;
    var secondaryCutoffPercentage = 100 - primaryCutoffPercentage || 50;
    var angle = (swatch === null || swatch === void 0 ? void 0 : swatch.angle) || 0;
    var color = (swatch === null || swatch === void 0 ? void 0 : swatch.secondaryColor) ? "linear-gradient(".concat(angle, "deg, ").concat(swatch === null || swatch === void 0 ? void 0 : swatch.color, " ").concat(primaryCutoffPercentage, "%, ").concat(swatch === null || swatch === void 0 ? void 0 : swatch.secondaryColor, " ").concat(secondaryCutoffPercentage, "%)") : swatch === null || swatch === void 0 ? void 0 : swatch.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-[50%] border border-border transition ".concat(validClass, " ").concat(availibilityClass, " ").concat(selectedClass),
        style: {
            background: isSelected && color === "#FFFFFF" ? "var(--off-white)" : color
        },
        children: [
            (swatch === null || swatch === void 0 ? void 0 : (ref = swatch.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                alt: value,
                className: "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover",
                height: "32",
                src: swatch.image.src,
                width: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-[50%] border-white transition-[border-width] duration-100 ".concat(isSelected ? "border-[3px]" : "border-[0px]")
            })
        ]
    });
}
ColorOptionIcon.displayName = "ColorOptionIcon";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValues/ProductColorOptionValue/ColorOptionButton.jsx




function ColorOptionButton(param) {
    var inventory = param.inventory, isLoading = param.isLoading, isSelected = param.isSelected, newSelectedOptions = param.newSelectedOptions, product = param.product, setSelectedOptions = param.setSelectedOptions, swatch = param.swatch, value = param.value, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, isSoldOut = param.isSoldOut;
    var ref, ref1;
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        if (!newSelectedOptions) return null;
        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
    }, [
        newSelectedOptions,
        product.variants
    ]);
    var optionValueIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref1 === void 0 ? void 0 : ref1.availableForSale) || false;
    var disabled = isLoading || !variantFromOptionValue;
    var isUnavailable = isSoldOut ? true : !optionValueIsAvailable && !disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": "".concat(value).concat(isUnavailable ? " is Sold Out" : ""),
        className: "group/color",
        disabled: disabled,
        onClick: function() {
            if (isSelected) return;
            setSelectedOptions(newSelectedOptions);
        },
        type: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionIcon, {
            disabled: disabled,
            isUnavailable: isUnavailable,
            isSelected: isSelected,
            swatch: swatch,
            value: value,
            enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
            isAllOutOfStock: isSoldOut
        })
    });
}
ColorOptionButton.displayName = "ColorOptionButton";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValues/ProductColorOptionValue/ColorOptionLink.jsx







function ColorOptionLink(param) {
    var groupingProductsMapByColor = param.groupingProductsMapByColor, isSelected = param.isSelected, newSelectedOptions = param.newSelectedOptions, swatch = param.swatch, value = param.value, disableGroupHistory = param.disableGroupHistory, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, soldOutQty = param.soldOutQty, needsSelection = param.needsSelection, optionChanges = param.optionChanges, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var ref, ref1, ref2;
    var selectedVariantFromOptions = (0,react.useMemo)(function() {
        var ref;
        if (!groupingProductsMapByColor || !newSelectedOptions) return null;
        var variants = (ref = groupingProductsMapByColor[newSelectedOptions.Color]) === null || ref === void 0 ? void 0 : ref.variants;
        if (!variants) return null;
        var bestMatch = null;
        var maxMatches = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var variant = _step.value;
                var selectedOptionsMap = variant.selectedOptionsMap;
                var matches = Object.keys(newSelectedOptions).reduce(function(count, key) {
                    return count + (newSelectedOptions[key] === selectedOptionsMap[key] ? 1 : 0);
                }, 0);
                if (matches >= maxMatches) {
                    maxMatches = matches;
                    bestMatch = variant;
                }
            };
            for(var _iterator = variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return bestMatch;
    }, [
        groupingProductsMapByColor,
        newSelectedOptions
    ]);
    var numberOfProperties = Object.keys(newSelectedOptions || {}).length;
    var numberOfPropertiesChanged = Object.keys(optionChanges || {}).length;
    var url = (0,react.useMemo)(function() {
        if (!selectedVariantFromOptions) return null;
        var params = "";
        if (true) {
            var search = window.location.search;
            params = new URLSearchParams(search);
            params.set("variant", selectedVariantFromOptions.legacyResourceId);
            if (!needsSelection) {
                params.set("s", needsSelection);
            } else {
                if (numberOfProperties > 2 && numberOfPropertiesChanged > 1) {
                    Object.entries(optionChanges).forEach(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key !== "Color") {
                            params.set(key, value.toString());
                        }
                    });
                }
            }
        }
        return "/products/".concat(selectedVariantFromOptions.product.handle, "?").concat(params);
    }, [
        selectedVariantFromOptions,
        needsSelection,
        optionChanges,
        numberOfPropertiesChanged
    ]);
    var ref3 = (0,dist.useProductInventoryByHandle)({
        handle: selectedVariantFromOptions === null || selectedVariantFromOptions === void 0 ? void 0 : (ref = selectedVariantFromOptions.product) === null || ref === void 0 ? void 0 : ref.handle,
        withInventory: false
    }), inventory = ref3.inventory, inventoryFetched = ref3.success;
    var groupIsLoading = !inventoryFetched;
    var totalQuantityAvailable = Object.values((inventory === null || inventory === void 0 ? void 0 : inventory.variants) || {}).reduce(function(total, variant) {
        return total + variant.quantityAvailable;
    }, 0);
    var isAllOutOfStock = totalQuantityAvailable <= soldOutQty;
    var optionValueIsAvailable = totalQuantityAvailable <= soldOutQty ? false : (inventory === null || inventory === void 0 ? void 0 : (ref1 = inventory.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[selectedVariantFromOptions === null || selectedVariantFromOptions === void 0 ? void 0 : selectedVariantFromOptions.id]) === null || ref2 === void 0 ? void 0 : ref2.availableForSale) || false;
    var disabled = !inventoryFetched || !selectedVariantFromOptions;
    var isUnavailable = !optionValueIsAvailable && !disabled && !needsSelection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
        "aria-label": "".concat(value).concat(isAllOutOfStock || isUnavailable ? " is Sold Out" : ""),
        className: "group/color",
        href: url,
        onClick: function(e) {
            if (isSelected) e.preventDefault();
            if ((groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.title) && (groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.handle)) {
                sessionStorage.setItem("savedCollectionTitle", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.title);
                sessionStorage.setItem("savedCollectionHandle", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.handle);
                sessionStorage.setItem("savedHistory", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.path);
            }
        },
        scroll: false,
        replace: disableGroupHistory ? true : false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionIcon, {
            isLoading: groupIsLoading,
            isUnavailable: isUnavailable,
            isSelected: isSelected,
            swatch: swatch,
            value: value,
            enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
            isAllOutOfStock: isAllOutOfStock
        })
    });
}
ColorOptionLink.displayName = "ColorOptionLink";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValues/ProductColorOptionValue/ProductColorOptionValue.jsx







function ProductColorOptionValue(param) {
    var groupingProductsMapByColor = param.groupingProductsMapByColor, inventory = param.inventory, isLoading = param.isLoading, isSelected = param.isSelected, name = param.name, product = param.product, selectedOptions = param.selectedOptions, setSelectedOptions = param.setSelectedOptions, value = param.value, swatches = param.swatches, disableGroupHistory = param.disableGroupHistory, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, isSoldOut = param.isSoldOut, soldOutQty = param.soldOutQty, needsSelection = param.needsSelection, optionChanges = param.optionChanges, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var ref;
    var isFromGrouping = (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed;
    var newSelectedOptions = (0,react.useMemo)(function() {
        return selectedOptions ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), (0,_define_property/* default */.Z)({}, name, value)) : null;
    }, [
        name,
        selectedOptions,
        value
    ]);
    var swatch = (0,react.useMemo)(function() {
        if (!swatches) return null;
        return swatches.find(function(param) {
            var swatchName = param.name;
            return (swatchName === null || swatchName === void 0 ? void 0 : swatchName.trim().toLowerCase()) === value.toLowerCase();
        }) || null;
    }, [
        swatches,
        value
    ]);
    return isFromGrouping ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionLink, {
        groupingProductsMapByColor: groupingProductsMapByColor,
        isSelected: isSelected,
        newSelectedOptions: newSelectedOptions,
        swatch: swatch,
        value: value,
        disableGroupHistory: disableGroupHistory,
        enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
        soldOutQty: soldOutQty,
        needsSelection: needsSelection,
        optionChanges: optionChanges,
        groupedBreadcrumbs: groupedBreadcrumbs
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionButton, {
        inventory: inventory,
        isLoading: isLoading,
        isSelected: isSelected,
        newSelectedOptions: newSelectedOptions,
        product: product,
        setSelectedOptions: setSelectedOptions,
        swatch: swatch,
        value: value,
        enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
        isSoldOut: isSoldOut
    });
}
ProductColorOptionValue.displayName = "ProductColorOptionValue";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValues/ProductColorOptionValue/index.js


// EXTERNAL MODULE: ./src/contexts/index.js + 2 modules
var contexts = __webpack_require__(1741);
;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductOptionValuesLabel.jsx







function ProductOptionValuesLabel(param) {
    var enabledsizeGuide = param.enabledsizeGuide, name = param.name, groupingProductsMapByColor = param.groupingProductsMapByColor, groupValues = param.groupValues, selectedOptions = param.selectedOptions, productType = param.productType, selectedValue = param.selectedValue, selectedColor = param.selectedColor, sizeGuides = param.sizeGuides, tabsEnabled = param.tabsEnabled, tabsLinkEnabled = param.tabsLinkEnabled, disableGroupHistory = param.disableGroupHistory, needsSelection = param.needsSelection, optionChanges = param.optionChanges, isProductTypePresent = param.isProductTypePresent, isFullWidthTabs = param.isFullWidthTabs, index = param.index, selectedTab = param.selectedTab, setSelectedTab = param.setSelectedTab, selected = param.selected, _isColor = param.isColor, isColor = _isColor === void 0 ? false : _isColor, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var ref = (0,contexts/* useGlobalContext */.bN)(), openModal = ref.actions.openModal;
    var trimmedColor = (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.includes("| ")) ? selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.split("| ")[1] : selectedColor;
    var valueToUse = (groupValues === null || groupValues === void 0 ? void 0 : groupValues.some(function(value) {
        return value === trimmedColor;
    })) ? trimmedColor : (groupValues === null || groupValues === void 0 ? void 0 : groupValues.find(function(value) {
        return value.endsWith("| ".concat(trimmedColor));
    })) || (groupValues === null || groupValues === void 0 ? void 0 : groupValues[0]);
    var newSelectedOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), {
        Color: valueToUse
    });
    var selectedVariantFromOptions = (0,react.useMemo)(function() {
        var ref;
        if (!groupingProductsMapByColor || !newSelectedOptions) return null;
        var variants = (ref = groupingProductsMapByColor[newSelectedOptions.Color]) === null || ref === void 0 ? void 0 : ref.variants;
        if (!variants) return null;
        var bestMatch = null;
        var maxMatches = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var variant = _step.value;
                var selectedOptionsMap = variant.selectedOptionsMap;
                var matches = Object.keys(newSelectedOptions).reduce(function(count, key) {
                    return count + (newSelectedOptions[key] === selectedOptionsMap[key] ? 1 : 0);
                }, 0);
                if (matches >= maxMatches) {
                    maxMatches = matches;
                    bestMatch = variant;
                }
            };
            for(var _iterator = variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return bestMatch;
    }, [
        groupingProductsMapByColor,
        newSelectedOptions
    ]);
    var numberOfProperties = selectedOptions ? Object.keys(selectedOptions).length : 0;
    var numberOfPropertiesChanged = optionChanges ? Object.keys(optionChanges).length : 0;
    var url = (0,react.useMemo)(function() {
        if (!selectedVariantFromOptions) return null;
        var params = "";
        if (true) {
            var search = window.location.search;
            params = new URLSearchParams(search);
            params.set("variant", selectedVariantFromOptions.legacyResourceId);
            if (!needsSelection) {
                params.set("s", needsSelection);
            } else {
                if (numberOfProperties > 2 && numberOfPropertiesChanged > 1) {
                    Object.entries(optionChanges).forEach(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key !== "Color") {
                            params.set(key, value.toString());
                        }
                    });
                }
            }
        }
        return "/products/".concat(selectedVariantFromOptions.product.handle, "?").concat(params);
    }, [
        selectedVariantFromOptions,
        needsSelection,
        optionChanges,
        numberOfPropertiesChanged
    ]);
    var handleSizeGuideClick = (0,react.useCallback)(function() {
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* SizeGuide */.$7, {
            productType: productType,
            sizeGuides: sizeGuides
        }));
    }, [
        productType,
        sizeGuides
    ]);
    var selectedClass = selectedValue && selectedTab === null || selectedTab !== null && index === selectedTab ? "border-primary bg-white" : "";
    return tabsEnabled && isProductTypePresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: url && tabsLinkEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
            href: url,
            className: "btn-inverse-light btn-sm shadow-hairline text-label !font-normal ".concat(selectedClass, " ").concat(isFullWidthTabs ? "flex-grow" : ""),
            id: "color-tabs-item-".concat(index),
            "data-hs-tab": "color-tabs-".concat(index),
            "aria-controls": "color-tabs-".concat(index),
            role: "tab",
            onClick: function(e) {
                if (selected) e.preventDefault();
                if ((groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.title) && (groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.handle)) {
                    sessionStorage.setItem("savedCollectionTitle", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.title);
                    sessionStorage.setItem("savedCollectionHandle", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.handle);
                    sessionStorage.setItem("savedHistory", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.path);
                }
            },
            scroll: false,
            replace: disableGroupHistory ? true : false,
            children: name
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: "btn-inverse-light btn-sm shadow-hairline text-label !font-normal ".concat(selectedClass, " ").concat(isFullWidthTabs ? "flex-grow" : ""),
            id: "color-tabs-item-".concat(index),
            "data-hs-tab": "color-tabs-".concat(index),
            "aria-controls": "color-tabs-".concat(index),
            role: "tab",
            onClick: function() {
                return setSelectedTab(index);
            },
            children: name
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-2 flex items-center justify-between gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-label text-darkGray",
                        children: name
                    }),
                    (selected && selectedValue || isColor && selectedValue) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm text-mediumGray",
                        children: selectedValue.split("|").length > 1 ? selectedValue.split("|")[1].trim() : selectedValue
                    })
                ]
            }),
            name === "Size" && enabledsizeGuide && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "text-underline text-xs",
                onClick: handleSizeGuideClick,
                type: "button",
                children: "Size Guide"
            })
        ]
    });
}
ProductOptionValuesLabel.displayName = "ProductOptionValuesLabel";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValues/ProductColorOptionValues.jsx











function ProductColorOptionValues(param) {
    var inventory = param.inventory, inventoryFetched = param.inventoryFetched, product = param.product, name = param.name, selectedOptions = param.selectedOptions, setSelectedOptions = param.setSelectedOptions, swatches = param.swatches, disableGroupHistory = param.disableGroupHistory, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, isSoldOut = param.isSoldOut, soldOutQty = param.soldOutQty, enabledGroupTabs = param.enabledGroupTabs, enabledGroupTabsLink = param.enabledGroupTabsLink, productTypeForGroupTabs = param.productTypeForGroupTabs, enabledGroupOptions = param.enabledGroupOptions, productTypeForGroupOptions = param.productTypeForGroupOptions, needsSelection = param.needsSelection, setNeedsSelection = param.setNeedsSelection, optionChanges = param.optionChanges, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var ref;
    var tabsEnabled = enabledGroupTabs;
    var isProductTypePresent = productTypeForGroupTabs === null || productTypeForGroupTabs === void 0 ? void 0 : productTypeForGroupTabs.some(function(item) {
        return (item === null || item === void 0 ? void 0 : item.productType) === (product === null || product === void 0 ? void 0 : product.productType);
    });
    var isFullWidthTabs = productTypeForGroupTabs === null || productTypeForGroupTabs === void 0 ? void 0 : productTypeForGroupTabs.some(function(item) {
        return (item === null || item === void 0 ? void 0 : item.fullWidthTabs) === true;
    });
    var optionsEnabled = enabledGroupOptions;
    var isProductTypePresentOptions = productTypeForGroupOptions === null || productTypeForGroupOptions === void 0 ? void 0 : productTypeForGroupOptions.some(function(item) {
        return (item === null || item === void 0 ? void 0 : item.productType) === (product === null || product === void 0 ? void 0 : product.productType);
    });
    var ref1 = (0,react.useState)(null), groupingProductsMapByColor = ref1[0], setGroupingProductsMapByColor = ref1[1];
    var ref2 = (0,react.useState)(null), selectedTab = ref2[0], setSelectedTab = ref2[1];
    var ref3 = (0,react.useState)(false), selectedlifecycleSubgroup = ref3[0], setSelectedlifecycleSubgroup = ref3[1];
    var ref4 = (0,react.useState)({
        default: []
    }), groupedItems = ref4[0], setGroupedItems = ref4[1];
    var ref5 = (0,react.useState)(null), selectedGroup = ref5[0], setSelectedGroup = ref5[1];
    var colorOptions = (0,react.useMemo)(function() {
        var ref;
        return ((ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product.grouping.options.find(function(option) {
            return option.name === "Color";
        }) : product.options.find(function(option) {
            return option.name === "Color";
        });
    }, [
        product
    ]);
    var selectedColor = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name];
    var findSelectedGroup = function(groups, selectedColor) {
        if (!groups) {
            return null;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var group = _step.value;
                if (group.values.includes(selectedColor)) {
                    return group;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    (0,react.useEffect)(function() {
        if (colorOptions && selectedColor) {
            var group = findSelectedGroup(colorOptions.groups, selectedColor);
            setSelectedGroup(group);
        }
    }, [
        colorOptions,
        selectedColor
    ]);
    var groupByLifecycleSubgroups = function(group) {
        var groupedItems = {
            default: []
        };
        group === null || group === void 0 ? void 0 : group.values.forEach(function(value) {
            var product = groupingProductsMapByColor === null || groupingProductsMapByColor === void 0 ? void 0 : groupingProductsMapByColor[value];
            if (product) {
                var ref, ref1;
                var lifecycleSubgroup = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.metafields) === null || ref === void 0 ? void 0 : ref.find(function(metafield) {
                    return (metafield === null || metafield === void 0 ? void 0 : metafield.key) === "lifecycle_subgroups";
                })) === null || ref1 === void 0 ? void 0 : ref1.value;
                if (lifecycleSubgroup) {
                    var parsedSubgroup = JSON.parse(lifecycleSubgroup)[0]; // Parse and extract the first element
                    if (!groupedItems[parsedSubgroup]) {
                        groupedItems[parsedSubgroup] = [];
                    }
                    groupedItems[parsedSubgroup].push(value);
                } else {
                    groupedItems.default.push(value);
                }
            } else {
                groupedItems.default.push(value);
            }
        });
        return groupedItems;
    };
    (0,react.useEffect)(function() {
        if (groupingProductsMapByColor && selectedGroup) {
            var ref;
            var groupedItems = groupByLifecycleSubgroups(selectedGroup);
            setGroupedItems(groupedItems);
            var hasMultipleKeys = ((ref = Object.keys(groupedItems)) === null || ref === void 0 ? void 0 : ref.length) > 1;
            setSelectedlifecycleSubgroup(hasMultipleKeys);
        }
    }, [
        selectedGroup,
        groupingProductsMapByColor
    ]);
    var renderColorOptions = function(group) {
        var groupedItems = groupByLifecycleSubgroups(group);
        var selectedValue = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-2.5",
            children: Object.keys(groupedItems).map(function(subgroup) {
                if (!groupedItems[subgroup] || groupedItems[subgroup].length === 0) {
                    return null;
                }
                var selectedClass = groupedItems[subgroup].includes(selectedValue) ? "block" : "hidden";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        subgroup !== "default" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-label text-darkGray",
                                    children: subgroup
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm text-mediumGray ".concat(selectedClass),
                                    children: selectedValue.split("|").length > 1 ? selectedValue.split("|")[1].trim() : selectedValue
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-wrap gap-[5px]",
                            children: groupedItems[subgroup].map(function(value) {
                                var isSelected = selectedColor === value;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductColorOptionValue, {
                                        groupingProductsMapByColor: groupingProductsMapByColor,
                                        inventory: inventory,
                                        isLoading: !inventoryFetched,
                                        isSelected: isSelected,
                                        name: name,
                                        product: product,
                                        selectedOptions: selectedOptions,
                                        setSelectedOptions: setSelectedOptions,
                                        value: value,
                                        swatches: swatches,
                                        disableGroupHistory: disableGroupHistory,
                                        enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
                                        isSoldOut: isSoldOut,
                                        soldOutQty: soldOutQty,
                                        needsSelection: needsSelection,
                                        setNeedsSelection: setNeedsSelection,
                                        optionChanges: optionChanges,
                                        groupedBreadcrumbs: groupedBreadcrumbs
                                    })
                                }, value);
                            })
                        })
                    ]
                }, subgroup);
            })
        });
    };
    var validGroups = (ref = colorOptions.groups) === null || ref === void 0 ? void 0 : ref.filter(function(group) {
        return (group === null || group === void 0 ? void 0 : group.values.length) > 0;
    });
    var renderTabs = function(group, index) {
        var groupHasSelectedColor = group === null || group === void 0 ? void 0 : group.values.includes(selectedColor);
        var groupName = group.name === "Default" ? "Solids" : group.name;
        var colorName = groupName.toLowerCase().trim().endsWith("colors") ? groupName : "".concat(groupName);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValuesLabel, {
            name: colorName,
            groupingProductsMapByColor: groupingProductsMapByColor,
            groupValues: group === null || group === void 0 ? void 0 : group.values,
            selectedOptions: selectedOptions,
            selectedValue: groupHasSelectedColor ? selectedColor : null,
            selectedColor: selectedColor,
            tabsEnabled: tabsEnabled,
            tabsLinkEnabled: enabledGroupTabsLink,
            disableGroupHistory: disableGroupHistory,
            needsSelection: needsSelection,
            optionChanges: optionChanges,
            isProductTypePresent: isProductTypePresent,
            isFullWidthTabs: isFullWidthTabs,
            index: index,
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            isColor: true,
            groupedBreadcrumbs: groupedBreadcrumbs
        }, index);
    };
    (0,react.useEffect)(function() {
        var ref;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed)) return;
        var fetchProductsForMap = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, productHandles, products;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            productHandles = product.grouping.products || [];
                            if ((ref = product.grouping.subgroups) === null || ref === void 0 ? void 0 : ref.length) {
                                product.grouping.subgroups.forEach(function(subgroup) {
                                    productHandles = (0,_to_consumable_array/* default */.Z)(productHandles).concat((0,_to_consumable_array/* default */.Z)(subgroup.products));
                                });
                            }
                            return [
                                4,
                                (0,utilities/* fetchProductsFromHandles */.H4)(productHandles)
                            ];
                        case 1:
                            products = _state.sent();
                            setGroupingProductsMapByColor(products === null || products === void 0 ? void 0 : products.reduce(function(acc, groupProduct) {
                                var ref, ref1;
                                var color = (ref = groupProduct.optionsMap) === null || ref === void 0 ? void 0 : (ref1 = ref.Color) === null || ref1 === void 0 ? void 0 : ref1[0];
                                if (!color) return acc;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, color, groupProduct));
                            }, {}));
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchProductsForMap() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProductsForMap();
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return tabsEnabled && isProductTypePresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: colorOptions.hasSubGroups ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-2.5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "flex flex-wrap gap-[5px]",
                        "aria-label": "Color Tabs",
                        role: "tablist",
                        children: validGroups.map(renderTabs)
                    })
                }),
                validGroups.map(function(group, index) {
                    var groupHasSelectedColor = group === null || group === void 0 ? void 0 : group.values.includes(selectedColor);
                    var selectedValue = groupHasSelectedColor ? selectedColor : null;
                    var selectedClass = groupHasSelectedColor && selectedTab === null || selectedTab !== null && index === selectedTab ? "block" : "hidden";
                    return selectedValue && !selectedlifecycleSubgroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-label text-darkGray",
                                children: "Color"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-mediumGray ".concat(selectedClass),
                                children: selectedValue.split("|").length > 1 ? selectedValue.split("|")[1].trim() : selectedValue
                            }, index)
                        ]
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: validGroups.map(function(group, index) {
                        var groupHasSelectedColor = group === null || group === void 0 ? void 0 : group.values.includes(selectedColor);
                        var selectedClass = groupHasSelectedColor && selectedTab === null || selectedTab !== null && index === selectedTab ? "block" : "hidden";
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "color-tabs-".concat(index),
                            role: "tabpanel",
                            "aria-labelledby": "color-tabs-item-".concat(index),
                            className: selectedClass,
                            children: renderColorOptions(group)
                        }, "color-tabs-".concat(index));
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValuesLabel, {
                    name: name,
                    selectedValue: selectedColor,
                    isColor: true
                }),
                renderColorOptions(colorOptions)
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: optionsEnabled && isProductTypePresentOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: colorOptions.hasSubGroups ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2.5",
                children: [
                    validGroups.map(function(group, index) {
                        var groupHasSelectedColor = group === null || group === void 0 ? void 0 : group.values.includes(selectedColor);
                        var selectedValue = groupHasSelectedColor ? selectedColor : null;
                        var selectedClass = groupHasSelectedColor && selectedTab === null || selectedTab !== null && index === selectedTab ? "block" : "hidden";
                        return selectedValue && !selectedlifecycleSubgroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-label text-darkGray",
                                    children: "Color"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm text-mediumGray ".concat(selectedClass),
                                    children: selectedValue.split("|").length > 1 ? selectedValue.split("|")[1].trim() : selectedValue
                                }, index)
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: validGroups.map(function(group, index) {
                            var groupHasSelectedColor = group === null || group === void 0 ? void 0 : group.values.includes(selectedColor);
                            var selectedClass = groupHasSelectedColor && selectedTab === null || selectedTab !== null && index === selectedTab ? "block" : "hidden";
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "color-tabs-".concat(index),
                                role: "tabpanel",
                                "aria-labelledby": "color-tabs-item-".concat(index),
                                className: selectedClass,
                                children: renderColorOptions(group)
                            }, "color-tabs-".concat(index));
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValuesLabel, {
                        name: name,
                        selectedValue: selectedColor,
                        isColor: true
                    }),
                    renderColorOptions(colorOptions)
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: colorOptions.hasSubGroups ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-2.5",
                children: colorOptions.groups.map(function(group, index) {
                    if (!(group === null || group === void 0 ? void 0 : group.values.length)) return null;
                    var selectedColor = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name];
                    var groupHasSelectedColor = group === null || group === void 0 ? void 0 : group.values.includes(selectedColor);
                    var groupName = group.name === "Default" ? "Solids" : group.name;
                    var colorName = groupName.toLowerCase().trim().endsWith("colors") ? groupName : "".concat(groupName);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValuesLabel, {
                                name: colorName,
                                selectedValue: groupHasSelectedColor ? selectedColor : null,
                                isColor: true
                            }),
                            renderColorOptions(group, selectedColor)
                        ]
                    }, index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValuesLabel, {
                        name: name,
                        selectedValue: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name],
                        isColor: true
                    }),
                    renderColorOptions(colorOptions, selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name])
                ]
            })
        })
    });
}
ProductColorOptionValues.displayName = "ProductColorOptionValues";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValues/index.js


;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductOptionValues/ProductOptionValue.jsx






function ProductOptionValue(param) {
    var inventory = param.inventory, isLoading = param.isLoading, isSelected = param.isSelected, selected = param.selected, name = param.name, product = param.product, selectedOptions = param.selectedOptions, setSelectedOptions = param.setSelectedOptions, value = param.value, isSoldOut = param.isSoldOut, moreThanTwoOptions = param.moreThanTwoOptions, secondOptionIsSoldOut = param.secondOptionIsSoldOut, needsSelection = param.needsSelection, optionChanges = param.optionChanges, setOptionChanges = param.setOptionChanges;
    var ref, ref1;
    var newSelectedOptions = (0,react.useMemo)(function() {
        return selectedOptions ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), (0,_define_property/* default */.Z)({}, name, value)) : null;
    }, [
        name,
        selectedOptions,
        value
    ]);
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        if (!newSelectedOptions) return null;
        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
    }, [
        newSelectedOptions,
        product.variants
    ]);
    var loadAsSoldOut = isSoldOut || secondOptionIsSoldOut;
    var optionValueIsAvailable = loadAsSoldOut ? false : (inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref1 === void 0 ? void 0 : ref1.availableForSale) || false;
    var disabled = isLoading || !variantFromOptionValue;
    var crossedOutClass = "relative opacity-50 text-gray overflow-hidden after:h-[.5px] after:w-[150%] after:absolute after:left-[-14px] after:bg-gray after:top-1/2 after:rotate-[35deg] before:h-[.5px] before:w-[150%] before:absolute before:left-[-14px] before:bg-gray before:top-1/2 before:rotate-[-35deg]";
    var validClass = !disabled ? "md:hover:border-text text-text bg-offWhite" : "cursor-not-allowed hidden";
    var unavailableClass = moreThanTwoOptions ? loadAsSoldOut ? crossedOutClass : needsSelection ? "" : !optionValueIsAvailable && !disabled ? crossedOutClass : "" : !optionValueIsAvailable && !disabled ? "relative opacity-50 text-gray overflow-hidden after:h-[.5px] after:w-[150%] after:absolute after:left-[-14px] after:bg-gray after:top-1/2 after:rotate-[35deg] before:h-[.5px] before:w-[150%] before:absolute before:left-[-14px] before:bg-gray before:top-1/2 before:rotate-[-35deg]" : "";
    var selectedClass = selected ? isSelected ? "bg-white border border-primary" : "" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": value,
        className: "shadow-hairline h-10 min-w-14 px-3 transition ".concat(validClass, " ").concat(unavailableClass, " ").concat(selectedClass),
        disabled: disabled,
        onClick: function() {
            if (isSelected && selected) return;
            if (isSelected && !selected) {
                setOptionChanges((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, optionChanges), (0,_define_property/* default */.Z)({}, name, true)));
            }
            setSelectedOptions(newSelectedOptions);
        },
        type: "button",
        children: value
    });
}
ProductOptionValue.displayName = "ProductOptionValue";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductOptionValues/ProductOptionValues.jsx



function ProductOptionValues(param) {
    var enabledsizeGuide = param.enabledsizeGuide, inventory = param.inventory, inventoryFetched = param.inventoryFetched, product = param.product, name = param.name, selectedOptions = param.selectedOptions, setSelectedOptions = param.setSelectedOptions, values = param.values, sizeGuides = param.sizeGuides, isSoldOut = param.isSoldOut, moreThanTwoOptions = param.moreThanTwoOptions, isSecondOption = param.isSecondOption, keysWithMatchingCount = param.keysWithMatchingCount, needsSelection = param.needsSelection, optionChanges = param.optionChanges, setOptionChanges = param.setOptionChanges;
    var ref;
    var productOrGroupingValues = ((ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product.grouping.optionsMap[name] : values;
    var selected = optionChanges.hasOwnProperty(name) && optionChanges[name] === true;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValuesLabel, {
                enabledsizeGuide: enabledsizeGuide,
                name: name,
                productType: product.productType,
                sizeGuides: sizeGuides,
                selectedValue: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name],
                selected: selected
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-wrap gap-[5px]",
                children: productOrGroupingValues === null || productOrGroupingValues === void 0 ? void 0 : productOrGroupingValues.map(function(value) {
                    var isSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name]) === value;
                    var secondOptionIsSoldOut = moreThanTwoOptions && isSecondOption && keysWithMatchingCount.includes(value);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValue, {
                            inventory: inventory,
                            isLoading: !inventoryFetched,
                            isSelected: isSelected,
                            selected: selected,
                            name: name,
                            product: product,
                            selectedOptions: selectedOptions,
                            setSelectedOptions: setSelectedOptions,
                            value: value,
                            isSoldOut: isSoldOut,
                            moreThanTwoOptions: moreThanTwoOptions,
                            secondOptionIsSoldOut: secondOptionIsSoldOut,
                            needsSelection: needsSelection,
                            optionChanges: optionChanges,
                            setOptionChanges: setOptionChanges
                        })
                    }, value);
                })
            })
        ]
    });
}
ProductOptionValues.displayName = "ProductOptionValues";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductOptionValues/index.js


;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductGroupOptions/ProductGroupOptionsOption.jsx







function ProductGroupOptionsOption(param) {
    var name = param.name, groupingProductsMapByColor = param.groupingProductsMapByColor, groupValues = param.groupValues, selectedOptions = param.selectedOptions, selectedValue = param.selectedValue, selectedColor = param.selectedColor, optionsEnabled = param.optionsEnabled, optionsLinkEnabled = param.optionsLinkEnabled, disableGroupHistory = param.disableGroupHistory, needsSelection = param.needsSelection, optionChanges = param.optionChanges, isProductTypePresent = param.isProductTypePresent, index = param.index, selectedTab = param.selectedTab, setSelectedTab = param.setSelectedTab, selected = param.selected, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var trimmedColor = (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.includes("| ")) ? selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.split("| ")[1] : selectedColor;
    var exactMatch = groupValues === null || groupValues === void 0 ? void 0 : groupValues.some(function(value) {
        return value === trimmedColor;
    });
    var partialMatch = groupValues === null || groupValues === void 0 ? void 0 : groupValues.find(function(value) {
        return value.endsWith("| ".concat(trimmedColor));
    });
    var valueToUse = exactMatch ? trimmedColor : partialMatch || null;
    var newSelectedOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), {
        Color: valueToUse
    });
    var selectedVariantFromOptions = (0,react.useMemo)(function() {
        var ref;
        if (!groupingProductsMapByColor || !newSelectedOptions) return null;
        var variants = (ref = groupingProductsMapByColor[newSelectedOptions.Color]) === null || ref === void 0 ? void 0 : ref.variants;
        if (!variants) return null;
        var bestMatch = null;
        var maxMatches = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var variant = _step.value;
                var selectedOptionsMap = variant.selectedOptionsMap;
                var matches = Object.keys(newSelectedOptions).reduce(function(count, key) {
                    return count + (newSelectedOptions[key] === selectedOptionsMap[key] ? 1 : 0);
                }, 0);
                if (matches >= maxMatches) {
                    maxMatches = matches;
                    bestMatch = variant;
                }
            };
            for(var _iterator = variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return bestMatch;
    }, [
        groupingProductsMapByColor,
        newSelectedOptions
    ]);
    var numberOfProperties = selectedOptions ? Object.keys(selectedOptions).length : 0;
    var numberOfPropertiesChanged = optionChanges ? Object.keys(optionChanges).length : 0;
    var url = (0,react.useMemo)(function() {
        if (!selectedVariantFromOptions) return null;
        var params = "";
        if (true) {
            var search = window.location.search;
            params = new URLSearchParams(search);
            params.set("variant", selectedVariantFromOptions.legacyResourceId);
            if (!needsSelection) {
                params.set("s", needsSelection);
            } else {
                if (numberOfProperties > 2 && numberOfPropertiesChanged > 1) {
                    Object.entries(optionChanges).forEach(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key !== "Color") {
                            params.set(key, value.toString());
                        }
                    });
                }
            }
        }
        return "/products/".concat(selectedVariantFromOptions.product.handle, "?").concat(params);
    }, [
        selectedVariantFromOptions,
        needsSelection,
        optionChanges,
        numberOfPropertiesChanged
    ]);
    var selectedClass = selectedValue && selectedTab === null || selectedTab !== null && index === selectedTab ? "bg-white border border-primary" : "";
    return optionsEnabled && isProductTypePresent && (exactMatch || partialMatch) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: url && optionsLinkEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
            href: url,
            className: "flex justify-center items-center shadow-hairline h-10 min-w-14 px-3 transition ".concat(selectedClass),
            id: "group-options-item-".concat(index),
            "data-hs-tab": "group-options-".concat(index),
            "aria-controls": "group-options-".concat(index),
            role: "tab",
            onClick: function(e) {
                if (selected) e.preventDefault();
                if ((groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.title) && (groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.handle)) {
                    sessionStorage.setItem("savedCollectionTitle", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.title);
                    sessionStorage.setItem("savedCollectionHandle", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.handle);
                    sessionStorage.setItem("savedHistory", groupedBreadcrumbs === null || groupedBreadcrumbs === void 0 ? void 0 : groupedBreadcrumbs.path);
                }
            },
            scroll: false,
            replace: disableGroupHistory ? true : false,
            children: name
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: "shadow-hairline h-10 min-w-14 px-3 transition ".concat(selectedClass),
            id: "group-options-item-".concat(index),
            "data-hs-tab": "group-options-".concat(index),
            "aria-controls": "group-options-".concat(index),
            role: "button",
            onClick: function() {
                return setSelectedTab(index);
            },
            children: name
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
ProductGroupOptionsOption.displayName = "ProductGroupOptionsOption";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductGroupOptions/ProductGroupOptions.jsx










function ProductGroupOptions(param) {
    var product = param.product, _name = param.name, name = _name === void 0 ? "Color" : _name, selectedOptions = param.selectedOptions, enabledGroupOptions = param.enabledGroupOptions, enabledGroupOptionsLink = param.enabledGroupOptionsLink, productTypeForGroupOptions = param.productTypeForGroupOptions, disableGroupHistory = param.disableGroupHistory, needsSelection = param.needsSelection, optionChanges = param.optionChanges, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var ref;
    var optionsEnabled = enabledGroupOptions;
    var isProductTypePresent = productTypeForGroupOptions === null || productTypeForGroupOptions === void 0 ? void 0 : productTypeForGroupOptions.some(function(item) {
        return (item === null || item === void 0 ? void 0 : item.productType) === (product === null || product === void 0 ? void 0 : product.productType);
    });
    var ref1 = (0,react.useState)(null), groupingProductsMapByColor = ref1[0], setGroupingProductsMapByColor = ref1[1];
    var ref2 = (0,react.useState)(null), selectedTab = ref2[0], setSelectedTab = ref2[1];
    var colorOptions = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        return (product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product === null || product === void 0 ? void 0 : (ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.options) === null || ref2 === void 0 ? void 0 : ref2.find(function(option) {
            return (option === null || option === void 0 ? void 0 : option.name) === "Color";
        }) : product === null || product === void 0 ? void 0 : (ref3 = product.options) === null || ref3 === void 0 ? void 0 : ref3.find(function(option) {
            return (option === null || option === void 0 ? void 0 : option.name) === "Color";
        });
    }, [
        product
    ]);
    var selectedColor = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name];
    var validGroups = colorOptions === null || colorOptions === void 0 ? void 0 : (ref = colorOptions.groups) === null || ref === void 0 ? void 0 : ref.filter(function(group) {
        var ref;
        return (group === null || group === void 0 ? void 0 : (ref = group.values) === null || ref === void 0 ? void 0 : ref.length) > 0;
    });
    var renderOptions = function(group, index) {
        var ref;
        var groupHasSelectedColor = group === null || group === void 0 ? void 0 : (ref = group.values) === null || ref === void 0 ? void 0 : ref.includes(selectedColor);
        var groupName = (group === null || group === void 0 ? void 0 : group.name) === "Default" ? "Solids" : group === null || group === void 0 ? void 0 : group.name;
        var colorName = (groupName === null || groupName === void 0 ? void 0 : groupName.toLowerCase().trim().endsWith("colors")) ? groupName : "".concat(groupName);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGroupOptionsOption, {
            name: colorName,
            groupingProductsMapByColor: groupingProductsMapByColor,
            groupValues: group === null || group === void 0 ? void 0 : group.values,
            selectedOptions: selectedOptions,
            selectedValue: groupHasSelectedColor ? selectedColor : null,
            selectedColor: selectedColor,
            optionsEnabled: optionsEnabled,
            optionsLinkEnabled: enabledGroupOptionsLink,
            disableGroupHistory: disableGroupHistory,
            needsSelection: needsSelection,
            optionChanges: optionChanges,
            isProductTypePresent: isProductTypePresent,
            index: index,
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            isColor: true,
            groupedBreadcrumbs: groupedBreadcrumbs
        }, index);
    };
    (0,react.useEffect)(function() {
        var ref;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed)) return;
        var fetchProductsForMap = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, productHandles, ref3, ref4, products;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            productHandles = (product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.products) || [];
                            if (product === null || product === void 0 ? void 0 : (ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subgroups) === null || ref2 === void 0 ? void 0 : ref2.length) {
                                ;
                                product === null || product === void 0 ? void 0 : (ref3 = product.grouping) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subgroups) === null || ref4 === void 0 ? void 0 : ref4.forEach(function(subgroup) {
                                    productHandles = (0,_to_consumable_array/* default */.Z)(productHandles).concat((0,_to_consumable_array/* default */.Z)(subgroup.products));
                                });
                            }
                            return [
                                4,
                                (0,utilities/* fetchProductsFromHandles */.H4)(productHandles)
                            ];
                        case 1:
                            products = _state.sent();
                            setGroupingProductsMapByColor(products === null || products === void 0 ? void 0 : products.reduce(function(acc, groupProduct) {
                                var ref, ref1;
                                var color = groupProduct === null || groupProduct === void 0 ? void 0 : (ref = groupProduct.optionsMap) === null || ref === void 0 ? void 0 : (ref1 = ref.Color) === null || ref1 === void 0 ? void 0 : ref1[0];
                                if (!color) return acc;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, color, groupProduct));
                            }, {}));
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchProductsForMap() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProductsForMap();
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return optionsEnabled && isProductTypePresent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 flex items-center justify-between gap-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center gap-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-label text-darkGray",
                        children: "Inseam /Style"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-wrap gap-[5px]",
                "aria-label": "Color Options",
                role: "tablist",
                children: validGroups === null || validGroups === void 0 ? void 0 : validGroups.map(renderOptions)
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-2 flex items-center justify-between gap-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center gap-2"
        })
    });
}
ProductGroupOptions.displayName = "ProductGroupOptions";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductGroupOptions/index.js


;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductOptions.jsx




function ProductOptions(param) {
    var enabledsizeGuide = param.enabledsizeGuide, product = param.product, selectedOptions = param.selectedOptions, setSelectedOptions = param.setSelectedOptions, inventory = param.inventory, inventoryFetched = param.inventoryFetched, sizeGuides = param.sizeGuides, swatches = param.swatches, disableGroupHistory = param.disableGroupHistory, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, isSoldOut = param.isSoldOut, soldOutQty = param.soldOutQty, enabledGroupTabs = param.enabledGroupTabs, enabledGroupTabsLink = param.enabledGroupTabsLink, productTypeForGroupTabs = param.productTypeForGroupTabs, enabledGroupOptions = param.enabledGroupOptions, enabledGroupOptionsLink = param.enabledGroupOptionsLink, productTypeForGroupOptions = param.productTypeForGroupOptions, needsSelection = param.needsSelection, optionChanges = param.optionChanges, setOptionChanges = param.setOptionChanges, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var ref, ref1;
    var moreThanTwoOptions = (product === null || product === void 0 ? void 0 : (ref = product.options) === null || ref === void 0 ? void 0 : ref.length) >= 3;
    var thirdOptionKey = Object.keys(product === null || product === void 0 ? void 0 : product.optionsMap)[2];
    var thirdOptionValue = thirdOptionKey ? product === null || product === void 0 ? void 0 : product.optionsMap[thirdOptionKey] : null;
    var optionsCount = thirdOptionValue ? Array.isArray(thirdOptionValue) ? thirdOptionValue.length : Object.keys(thirdOptionValue).length : 0;
    var variantsWithAvailableForSaleFalse = (inventory === null || inventory === void 0 ? void 0 : inventory.variants) ? Object.values(inventory.variants).filter(function(variant) {
        return !variant.availableForSale;
    }) : [];
    var unavailableProductVariants = product === null || product === void 0 ? void 0 : product.variants.filter(function(variant) {
        return variantsWithAvailableForSaleFalse.some(function(unavailableVariant) {
            return unavailableVariant.id === variant.id;
        });
    });
    var secondPropertyValues = unavailableProductVariants.map(function(variant) {
        var keys = Object.keys(variant.selectedOptionsMap);
        var secondKey = keys[1];
        return variant.selectedOptionsMap[secondKey];
    });
    var countByValue = secondPropertyValues.reduce(function(acc, value) {
        acc[value] = (acc[value] || 0) + 1;
        return acc;
    }, {});
    var keysWithMatchingCount = Object.keys(countByValue).filter(function(key) {
        return countByValue[key] === optionsCount;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "select-option",
        className: "flex flex-col gap-2.5 max-md:pt-[var(--header-height)] max-md:-mt-[var(--header-height)]",
        children: [
            (ref1 = product.options) === null || ref1 === void 0 ? void 0 : ref1.map(function(param, index) {
                var id = param.id, name = param.name, values = param.values;
                var isSecondOption = index === 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: name === "Color" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductColorOptionValues, {
                        inventory: inventory,
                        inventoryFetched: inventoryFetched,
                        product: product,
                        name: name,
                        selectedOptions: selectedOptions,
                        setSelectedOptions: setSelectedOptions,
                        swatches: swatches,
                        disableGroupHistory: disableGroupHistory,
                        enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
                        isSoldOut: isSoldOut,
                        soldOutQty: soldOutQty,
                        enabledGroupTabs: enabledGroupTabs,
                        enabledGroupTabsLink: enabledGroupTabsLink,
                        productTypeForGroupTabs: productTypeForGroupTabs,
                        enabledGroupOptions: enabledGroupOptions,
                        enabledGroupOptionsLink: enabledGroupOptionsLink,
                        productTypeForGroupOptions: productTypeForGroupOptions,
                        needsSelection: needsSelection,
                        optionChanges: optionChanges,
                        setOptionChanges: setOptionChanges,
                        groupedBreadcrumbs: groupedBreadcrumbs
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValues, {
                            enabledsizeGuide: enabledsizeGuide,
                            inventory: inventory,
                            inventoryFetched: inventoryFetched,
                            product: product,
                            name: name,
                            selectedOptions: selectedOptions,
                            setSelectedOptions: setSelectedOptions,
                            values: values,
                            sizeGuides: sizeGuides,
                            isSoldOut: isSoldOut,
                            moreThanTwoOptions: moreThanTwoOptions,
                            isSecondOption: isSecondOption,
                            keysWithMatchingCount: keysWithMatchingCount,
                            needsSelection: needsSelection,
                            optionChanges: optionChanges,
                            setOptionChanges: setOptionChanges
                        })
                    })
                }, id);
            }),
            enabledGroupOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGroupOptions, {
                product: product,
                // name={name}
                selectedOptions: selectedOptions,
                enabledGroupOptions: enabledGroupOptions,
                enabledGroupOptionsLink: enabledGroupOptionsLink,
                productTypeForGroupOptions: productTypeForGroupOptions,
                disableGroupHistory: disableGroupHistory,
                needsSelection: needsSelection,
                optionChanges: optionChanges,
                groupedBreadcrumbs: groupedBreadcrumbs
            }) : null
        ]
    });
}
ProductOptions.displayName = "ProductOptions";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/index.js


;// CONCATENATED MODULE: ./src/templates/product/ProductSelection.jsx



function ProductSelection(param) {
    var enabledQuantitySelector = param.enabledQuantitySelector, product = param.product, selectedOptions = param.selectedOptions, selectedVariant = param.selectedVariant, setSelectedOptions = param.setSelectedOptions, isGiftCard = param.isGiftCard, inventory = param.inventory, inventoryFetched = param.inventoryFetched, quantity = param.quantity, handleDecrement = param.handleDecrement, handleIncrement = param.handleIncrement, isSticky = param.isSticky, refElement = param.refElement, lowInventoryNotification = param.lowInventoryNotification, enabledsizeGuide = param.enabledsizeGuide, sizeGuides = param.sizeGuides, swatches = param.swatches, disableGroupHistory = param.disableGroupHistory, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, isSoldOut = param.isSoldOut, soldOutQty = param.soldOutQty, enabledGroupTabs = param.enabledGroupTabs, enabledGroupTabsLink = param.enabledGroupTabsLink, productTypeForGroupTabs = param.productTypeForGroupTabs, enabledGroupOptions = param.enabledGroupOptions, enabledGroupOptionsLink = param.enabledGroupOptionsLink, productTypeForGroupOptions = param.productTypeForGroupOptions, needsSelection = param.needsSelection, optionChanges = param.optionChanges, setOptionChanges = param.setOptionChanges, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var ref, ref1, ref2, ref3;
    var hideOptions = ((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 && ((ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[0].title) === "Default Title";
    var lowInventoryQty = soldOutQty + (lowInventoryNotification === null || lowInventoryNotification === void 0 ? void 0 : lowInventoryNotification.qty);
    var lowInventoryMinQty = soldOutQty + 3;
    var selectedVariantId = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id;
    var ref4;
    var quantityAvailable = (ref4 = inventory === null || inventory === void 0 ? void 0 : (ref2 = inventory.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[selectedVariantId]) === null || ref3 === void 0 ? void 0 : ref3.quantityAvailable) !== null && ref4 !== void 0 ? ref4 : null;
    var selectedInventoryQty = quantityAvailable - soldOutQty;
    var isLowInventory = (inventory === null || inventory === void 0 ? void 0 : inventory.totalInventory) <= lowInventoryQty;
    var isLowInventoryQty = quantityAvailable <= lowInventoryQty;
    var isLowInventoryMin = quantityAvailable <= lowInventoryMinQty;
    var lowInventoryMessage = isLowInventory ? needsSelection ? lowInventoryNotification === null || lowInventoryNotification === void 0 ? void 0 : lowInventoryNotification.message : isLowInventoryMin ? "Only ".concat(selectedInventoryQty, " left in stock") : lowInventoryNotification === null || lowInventoryNotification === void 0 ? void 0 : lowInventoryNotification.message : isLowInventoryQty ? isLowInventoryMin ? "Only ".concat(selectedInventoryQty, " left in stock") : lowInventoryNotification === null || lowInventoryNotification === void 0 ? void 0 : lowInventoryNotification.message : null;
    var enabledLowInventory = (lowInventoryNotification === null || lowInventoryNotification === void 0 ? void 0 : lowInventoryNotification.enabled) && !isGiftCard && inventoryFetched && !isSoldOut && quantityAvailable > soldOutQty ? isLowInventory || isLowInventoryQty && !needsSelection : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-5",
        children: [
            !isSticky && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2.5",
                children: [
                    !hideOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                        product: product,
                        selectedOptions: selectedOptions,
                        inventory: inventory,
                        inventoryFetched: inventoryFetched,
                        setSelectedOptions: setSelectedOptions,
                        enabledsizeGuide: enabledsizeGuide,
                        sizeGuides: sizeGuides,
                        swatches: swatches,
                        disableGroupHistory: disableGroupHistory,
                        enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
                        isSoldOut: isSoldOut,
                        soldOutQty: soldOutQty,
                        enabledGroupTabs: enabledGroupTabs,
                        enabledGroupTabsLink: enabledGroupTabsLink,
                        productTypeForGroupTabs: productTypeForGroupTabs,
                        enabledGroupOptions: enabledGroupOptions,
                        enabledGroupOptionsLink: enabledGroupOptionsLink,
                        productTypeForGroupOptions: productTypeForGroupOptions,
                        needsSelection: needsSelection,
                        optionChanges: optionChanges,
                        setOptionChanges: setOptionChanges,
                        groupedBreadcrumbs: groupedBreadcrumbs
                    }),
                    enabledQuantitySelector && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-label text-darkGray",
                                children: "Quantity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* QuantitySelector */.cw, {
                                disableDecrement: quantity === 1,
                                handleDecrement: handleDecrement,
                                handleIncrement: handleIncrement,
                                productTitle: product.title,
                                quantity: quantity
                            })
                        ]
                    }),
                    enabledLowInventory && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm text-secondary mt-2.5 mb-0",
                        children: lowInventoryMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: refElement,
                className: "flex-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AddToCart */.o4, {
                    isPdp: true,
                    quantity: quantity,
                    selectedVariant: selectedVariant,
                    optionChanges: optionChanges,
                    needsSelection: needsSelection,
                    forceSoldOut: isSoldOut
                })
            })
        ]
    });
}
ProductSelection.displayName = "ProductSelection";

// EXTERNAL MODULE: ./src/snippets/Svg/index.js + 1 modules
var Svg = __webpack_require__(8970);
;// CONCATENATED MODULE: ./src/templates/product/ProductDetails.jsx




function ProductDetails(param) {
    var enabledQuantitySelector = param.enabledQuantitySelector, enabledTrustBuilders = param.enabledTrustBuilders, product = param.product, productDetailAccordionsSection = param.productDetailAccordionsSection, selectedOptions = param.selectedOptions, selectedVariant = param.selectedVariant, setSelectedOptions = param.setSelectedOptions, isGiftCard = param.isGiftCard, inventory = param.inventory, inventoryFetched = param.inventoryFetched, quantity = param.quantity, handleDecrement = param.handleDecrement, handleIncrement = param.handleIncrement, refElement = param.refElement, lowInventoryNotification = param.lowInventoryNotification, enabledsizeGuide = param.enabledsizeGuide, sizeGuides = param.sizeGuides, swatches = param.swatches, disableGroupHistory = param.disableGroupHistory, enabledSoldOutColorSwatch = param.enabledSoldOutColorSwatch, isSoldOut = param.isSoldOut, soldOutQty = param.soldOutQty, enabledGroupTabs = param.enabledGroupTabs, enabledGroupTabsLink = param.enabledGroupTabsLink, productTypeForGroupTabs = param.productTypeForGroupTabs, enabledGroupOptions = param.enabledGroupOptions, enabledGroupOptionsLink = param.enabledGroupOptionsLink, productTypeForGroupOptions = param.productTypeForGroupOptions, needsSelection = param.needsSelection, optionChanges = param.optionChanges, setOptionChanges = param.setOptionChanges, groupedBreadcrumbs = param.groupedBreadcrumbs;
    var descriptionRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var isFinalSale = product.tags.includes("Final Sale");
    var toggleExpansion = (0,react.useCallback)(function() {
        setIsExpanded(!isExpanded);
    }, [
        isExpanded
    ]);
    (0,react.useEffect)(function() {
        if (descriptionRef.current.clientHeight > 100) {
            setIsExpanded(false);
        } else {
            setIsExpanded(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSelection, {
                enabledQuantitySelector: enabledQuantitySelector,
                product: product,
                selectedOptions: selectedOptions,
                selectedVariant: selectedVariant,
                setSelectedOptions: setSelectedOptions,
                isGiftCard: isGiftCard,
                inventory: inventory,
                inventoryFetched: inventoryFetched,
                isSoldOut: isSoldOut,
                quantity: quantity,
                handleDecrement: handleDecrement,
                handleIncrement: handleIncrement,
                refElement: refElement,
                lowInventoryNotification: lowInventoryNotification,
                enabledsizeGuide: enabledsizeGuide,
                sizeGuides: sizeGuides,
                swatches: swatches,
                disableGroupHistory: disableGroupHistory,
                enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
                soldOutQty: soldOutQty,
                enabledGroupTabs: enabledGroupTabs,
                enabledGroupTabsLink: enabledGroupTabsLink,
                productTypeForGroupTabs: productTypeForGroupTabs,
                enabledGroupOptions: enabledGroupOptions,
                enabledGroupOptionsLink: enabledGroupOptionsLink,
                productTypeForGroupOptions: productTypeForGroupOptions,
                needsSelection: needsSelection,
                optionChanges: optionChanges,
                setOptionChanges: setOptionChanges,
                groupedBreadcrumbs: groupedBreadcrumbs
            }),
            enabledTrustBuilders && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-2.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-1/2 flex flex-row items-center gap-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "text-text",
                                    src: "/svgs/free-shipping.svg#free-shipping",
                                    alt: "Free Shipping Icon",
                                    title: "Free Shipping",
                                    viewBox: "0 0 48 48",
                                    width: "48px",
                                    height: "48px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "uppercase mb-0",
                                        children: "Free Standard Shipping"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0",
                                        children: "On domestic orders $150+"
                                    })
                                ]
                            })
                        ]
                    }),
                    !isFinalSale && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-1/2 flex flex-row items-center gap-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "text-text",
                                    src: "/svgs/free-returns.svg#free-returns",
                                    alt: "Free Returns Icon",
                                    title: "Free Returns",
                                    viewBox: "0 0 48 48",
                                    width: "48px",
                                    height: "48px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "uppercase mb-0",
                                        children: "Free Returns & Exchanges"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0",
                                        children: "30 days after purchase"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: descriptionRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overflow-hidden ".concat(isExpanded ? "h-auto" : "h-28"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML: {
                                    __html: product.descriptionHtml
                                },
                                className: "text-base [&>:last-child]:mb-0 [&_a]:underline [&_blockquote]:pl-8 [&_h1]:mb-3 [&_h2]:mb-3 [&_h3]:mb-3 [&_h4]:mb-3 [&_h5]:mb-3 [&_h6]:mb-3 [&_li>p]:mb-0 [&_li]:mb-2 [&_ol>li]:list-decimal [&_ol]:mb-3 [&_ol]:pl-8 [&_p]:mb-3 [&_ul>li]:list-disc [&_ul]:mb-3 [&_ul]:pl-8"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full ".concat(isExpanded ? "relative" : "absolute bottom-0"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-28 bg-gradient-to-b from-transparent to-white ".concat(isExpanded ? "hidden" : "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row justify-center bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: toggleExpansion,
                                    className: "review-more-button flex-row text-xs",
                                    "aria-label": "".concat(isExpanded ? "Collapse" : "Expand", " product description"),
                                    type: "button",
                                    children: isExpanded ? "- Read less" : "+ Read more"
                                })
                            })
                        ]
                    })
                ]
            }),
            productDetailAccordionsSection || null
        ]
    });
}
ProductDetails.displayName = "ProductDetails";

;// CONCATENATED MODULE: ./src/templates/product/ProductHeader.jsx





function ProductHeader(param) {
    var isMobile = param.isMobile, isMobileViewport = param.isMobileViewport, product = param.product, isGiftCard = param.isGiftCard, selectedVariant = param.selectedVariant, productTitleMobilePlacement = param.productTitleMobilePlacement, smoothScrollTo = param.smoothScrollTo, note = param.note, headerExtraClasses = param.headerExtraClasses;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,hooks/* useVariantPrices */.be)({
        variant: selectedVariant
    }), price = ref4.price, compareAtPrice = ref4.compareAtPrice;
    var priceNumber = Number(price === null || price === void 0 ? void 0 : price.replace("$", ""));
    var compareAtPriceNumber = Number(compareAtPrice === null || compareAtPrice === void 0 ? void 0 : compareAtPrice.replace("$", ""));
    var discountPercentage = (compareAtPriceNumber - priceNumber) / compareAtPriceNumber * 100;
    var settings = (0,dist.useSettings)();
    var ref5 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.details), enabledProductType = ref5.enabledProductType, enabledColorName = ref5.enabledColorName, enabledShopPayInstallments = ref5.enabledShopPayInstallments, finalSaleText = ref5.finalSaleText;
    var enabledStarRating = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref1 = settings.product) === null || ref1 === void 0 ? void 0 : ref1.reviews).enabledStarRating;
    var isVisibleHeader = isMobile && isMobileViewport || !isMobile && !isMobileViewport;
    var headerClasses = productTitleMobilePlacement === "aboveImage" ? isMobile ? "col-span-12 md:hidden" : "max-md:hidden" : headerExtraClasses;
    var productTitle = product.title.split(" | ")[0];
    var hasNote = note !== undefined && note !== null;
    var isFinalSale = product.tags.includes("Final Sale");
    var installmentsPrice = (priceNumber / 4).toFixed(2);
    var installmentsMessage = priceNumber < 50 ? "Pay in 4 interest-free installments for orders over $50.00 with" : priceNumber < 150 ? "Pay in 4 interest-free installments of $".concat(installmentsPrice, " with") : "4 interest-free installments, or from $".concat(installmentsPrice, "/mo with");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: headerClasses,
        children: [
            enabledStarRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ProductStars */.nH, {
                productId: product === null || product === void 0 ? void 0 : product.legacyResourceId
            }),
            isVisibleHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-title-h1 normal-case",
                children: productTitle
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-title-h2 normal-case",
                children: productTitle
            }),
            enabledProductType && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-title-h5",
                children: product.productType
            }),
            enabledColorName && ((ref2 = product.optionsMap) === null || ref2 === void 0 ? void 0 : ref2.Color) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-title-h6",
                children: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.selectedOptionsMap) === null || ref3 === void 0 ? void 0 : ref3.Color
            }),
            compareAtPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-0 flex items-baseline gap-1 md:mt-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-title-h4 leading-none text-secondary",
                                "aria-label": "Current price ".concat(price),
                                children: price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xl text-mediumGray line-through",
                                "aria-label": "Original price ".concat(compareAtPrice),
                                children: compareAtPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-title-h6 text-secondary",
                        children: [
                            discountPercentage.toFixed(0),
                            "% off",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: " (".concat(discountPercentage.toFixed(0), "% discount applied)")
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-0 flex gap-1 md:mt-2.5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-title-h4 leading-none",
                    "aria-label": "Price ".concat(price),
                    children: price
                })
            }),
            enabledShopPayInstallments && !isGiftCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm",
                id: "shopify-installments",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    id: "shopify-installments-content",
                    className: "flex",
                    children: [
                        installmentsMessage,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                            className: "ml-1 w-[59px]",
                            role: "img",
                            src: "/svgs/noprecache/icons/ShopPay.svg#ShopPay",
                            alt: "Shop Pay",
                            title: "Shop Pay",
                            "aria-label": "Shop Pay",
                            viewBox: "0 0 683 164"
                        })
                    ]
                })
            }),
            isFinalSale && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-secondary",
                children: finalSaleText
            }),
            hasNote && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-body text-mediumGray",
                children: note === null || note === void 0 ? void 0 : note.value
            })
        ]
    });
}
ProductHeader.displayName = "ProductHeader";

// EXTERNAL MODULE: ../node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(5771);
// EXTERNAL MODULE: ../node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(4846);
// EXTERNAL MODULE: ../node_modules/react-zoom-pan-pinch/dist/index.esm.js
var index_esm = __webpack_require__(5781);
;// CONCATENATED MODULE: ./src/templates/product/ProductMedia/ProductImage.jsx





function ProductImage(param) {
    var alt = param.alt, image = param.image, onLoad = param.onLoad, priority = param.priority, _enabledZoom = param.enabledZoom, enabledZoom = _enabledZoom === void 0 ? false : _enabledZoom, cursorStyle = param.cursorStyle, isMobileViewport = param.isMobileViewport, swiperInstance = param.swiperInstance;
    var ref = (0,react_intersection_observer_dist/* useInView */.YD)({
        threshold: 0,
        triggerOnce: false
    }), ref1 = ref.ref, inView = ref.inView;
    // Add state for zoom and transform origin
    var ref2 = (0,react.useState)(false), isZoomed = ref2[0], setIsZoomed = ref2[1];
    var ref3 = (0,react.useState)("50% 50%"), transformOrigin = ref3[0], setTransformOrigin = ref3[1];
    // Handle zoom toggle
    var handleZoomToggle = function(e) {
        if (!enabledZoom || isMobileViewport) return;
        var ref = e.currentTarget.getBoundingClientRect(), left = ref.left, top = ref.top, width = ref.width, height = ref.height;
        var x = (e.clientX - left) / width * 100;
        var y = (e.clientY - top) / height * 100;
        setTransformOrigin("".concat(x, "% ").concat(y, "%"));
        setIsZoomed(!isZoomed);
    };
    // Handle mouse move for zoom effect
    var handleMouseMove = function(e) {
        if (!enabledZoom || !isZoomed || isMobileViewport) return;
        var ref = e.currentTarget.getBoundingClientRect(), left = ref.left, top = ref.top, width = ref.width, height = ref.height;
        var x = (e.clientX - left) / width * 100;
        var y = (e.clientY - top) / height * 100;
        setTransformOrigin("".concat(x, "% ").concat(y, "%"));
    };
    // Handle mouse leave
    var handleMouseLeave = function() {
        setIsZoomed(false);
    };
    // Disable Swiper draggable when zoom is enabled
    (0,react.useEffect)(function() {
        if (swiperInstance) {
            swiperInstance.allowTouchMove = !isZoomed;
        }
    }, [
        isZoomed,
        swiperInstance
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative bg-offWhite aspect-[4/5] overflow-hidden",
        ref: ref1,
        onClick: handleZoomToggle,
        onMouseMove: enabledZoom && !isMobileViewport ? handleMouseMove : undefined,
        onMouseLeave: enabledZoom && !isMobileViewport ? handleMouseLeave : undefined,
        children: (priority || inView) && (image === null || image === void 0 ? void 0 : image.src) && (isMobileViewport ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformWrapper */.d$, {
            doubleClick: {
                mode: "zoomIn"
            },
            wheel: {
                step: 5
            },
            zoomIn: {
                step: 5
            },
            zoomOut: {
                step: 5
            },
            initialScale: 1,
            minScale: 1,
            maxScale: 4,
            style: {
                width: "100%",
                height: "100%"
            },
            options: {
                limitToBounds: false,
                disabled: true
            },
            panning: {
                disabled: true
            },
            pinch: {
                step: 5,
                disabled: false
            },
            onZoomChange: function(ref) {
                if (swiperInstance) {
                    swiperInstance.allowTouchMove = ref.state.scale === 1;
                }
            },
            onPinchingStart: function() {
                if (swiperInstance) {
                    swiperInstance.allowTouchMove = false;
                }
            },
            onPinchingStop: function() {
                if (swiperInstance) {
                    swiperInstance.allowTouchMove = true;
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
                wrapperStyle: {
                    width: "100%",
                    height: "100%"
                },
                contentStyle: {
                    width: "100%",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    alt: alt,
                    onLoad: onLoad,
                    src: image.src,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
            alt: alt,
            fill: true,
            onLoad: onLoad,
            priority: priority,
            sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
            src: image.src,
            srcSetSizes: [
                480,
                960,
                1280,
                1920
            ],
            quality: 100,
            style: {
                transition: enabledZoom ? "transform 0.1s ease-out" : "none",
                transform: isZoomed ? "scale(2)" : "scale(1)",
                transformOrigin: transformOrigin,
                cursor: cursorStyle
            }
        }))
    });
}
ProductImage.displayName = "ProductImage";

;// CONCATENATED MODULE: ./src/templates/product/ProductMedia/ProductMediaThumbnail.jsx


function ProductMediaThumbnail(param) {
    var alt = param.alt, index = param.index, isActive = param.isActive, _mediaContentType = param.mediaContentType, mediaContentType = _mediaContentType === void 0 ? "IMAGE" : _mediaContentType, src = param.src, swiper = param.swiper;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        "aria-label": "Slide to product image ".concat(index + 1),
        className: "relative flex aspect-square w-full items-center justify-center overflow-hidden transition ".concat(isActive ? "border border-primary" : ""),
        onClick: function() {
            return swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(index);
        },
        type: "button",
        role: "button",
        tabIndex: "0",
        children: [
            src && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                alt: alt,
                className: "object-cover",
                height: "80",
                priority: index < 6,
                src: src,
                width: "80"
            }),
            mediaContentType === "VIDEO" && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                className: "absolute top-1/2 left-1/2 w-1/3 -translate-x-1/2 -translate-y-1/2 text-white",
                src: "/svgs/play.svg#play",
                alt: "Play Video Icon",
                title: "Play",
                viewBox: "0 0 24 24"
            })
        ]
    });
}
ProductMediaThumbnail.displayName = "ProductMediaThumbnail";

;// CONCATENATED MODULE: ./src/templates/product/ProductMedia/ProductMediaThumbnails.jsx





function ProductMediaThumbnails(param) {
    var product = param.product, activeIndex = param.activeIndex, selectedMedia = param.selectedMedia, setActiveIndex = param.setActiveIndex, swiper = param.swiper;
    var ref = (0,react.useState)(null), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !thumbsSwiper && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 z-[2] flex w-full flex-row gap-2 lg:flex-col lg:gap-3",
                children: selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.slice(0, 6).map(function(param, index) {
                    var id = param.id, mediaContentType = param.mediaContentType, preview = param.preview, product = param.product;
                    var ref;
                    var isActive = index === activeIndex;
                    var previewSrc = preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.previewSrc;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaThumbnail, {
                        alt: product.title,
                        index: index,
                        isActive: isActive,
                        mediaContentType: mediaContentType,
                        src: previewSrc
                    }, id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                modules: [
                    swiper_esm/* A11y */.s5,
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Keyboard */.N1
                ],
                a11y: {
                    enabled: true
                },
                className: "max-lg:absolute max-lg:top-0 max-lg:left-0 max-lg:w-full lg:h-full",
                grabCursor: true,
                onSwiper: setThumbsSwiper,
                preventClicks: false,
                preventClicksPropagation: false,
                slidesPerView: 6,
                spaceBetween: 8,
                onSlideChange: function(_swiper) {
                    setActiveIndex(_swiper.realIndex);
                    swiper.slideTo(_swiper.realIndex);
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    disabledClass: "hidden opacity-0"
                },
                breakpoints: {
                    1024: {
                        direction: "vertical",
                        slidesPerView: 5,
                        spaceBetween: 12
                    },
                    1280: {
                        direction: "vertical",
                        slidesPerView: 6,
                        spaceBetween: 12
                    }
                },
                role: "region",
                "aria-label": "".concat(product === null || product === void 0 ? void 0 : product.title, " Gallery Slider Navigation"),
                tabIndex: "0",
                children: [
                    selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.map(function(param, index) {
                        var id = param.id, mediaContentType = param.mediaContentType, preview = param.preview, product = param.product;
                        var ref;
                        var isActive = index === activeIndex;
                        var previewSrc = preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.previewSrc;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: "p-px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaThumbnail, {
                                alt: product.title,
                                index: index,
                                isActive: isActive,
                                mediaContentType: mediaContentType,
                                src: previewSrc,
                                swiper: swiper
                            })
                        }, id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "swiper-button-prev !left-0 !text-black opacity-90 flex cursor-pointer after:flex after:h-5 after:w-5 after:items-center after:justify-center after:overflow-hidden after:rounded-[50%] after:bg-white after:!text-[0.6rem] after:!content-['prev'] lg:!left-1/2 lg:!top-5 lg:!-translate-x-1/2 lg:!rotate-90",
                        "aria-label": "Previous Slide",
                        type: "button",
                        role: "button"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "swiper-button-next !right-0 !text-black opacity-90 flex cursor-pointer after:flex after:h-5 after:w-5 after:items-center after:justify-center after:overflow-hidden after:rounded-[50%] after:bg-white after:!text-[0.6rem] after:!content-['next'] lg:!top-auto lg:!left-1/2 lg:!bottom-0 lg:!-translate-x-1/2 lg:!rotate-90",
                        "aria-label": "Next Slide",
                        type: "button",
                        role: "button"
                    })
                ]
            })
        ]
    });
}
ProductMediaThumbnails.displayName = "ProductMediaThumbnails";

;// CONCATENATED MODULE: ./src/templates/product/ProductMedia/ProductVideo.jsx



function ProductVideo(param) {
    var media = param.media, onLoad = param.onLoad;
    var ref;
    var videoRef = (0,react.useRef)(null);
    var ref1 = (0,react_intersection_observer_dist/* useInView */.YD)({
        threshold: 0
    }), ref2 = ref1.ref, inView = ref1.inView;
    var sources = media.sources, preview = media.preview;
    var videoSources = sources === null || sources === void 0 ? void 0 : sources.filter(function(param) {
        var mimeType = param.mimeType;
        return mimeType === "video/mp4";
    });
    (0,react.useEffect)(function() {
        if (inView) {
            videoRef.current.play();
            onLoad();
        } else {
            videoRef.current.pause();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
            ref: videoRef,
            muted: true,
            playsInline: true,
            loop: true,
            controls: false,
            poster: preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.src,
            className: "w-full",
            children: inView && (videoSources === null || videoSources === void 0 ? void 0 : videoSources.length) ? videoSources.map(function(source) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: source.url,
                    type: source.mimeType
                }, source.url);
            }) : null
        })
    });
}
ProductVideo.displayName = "ProductVideo";

;// CONCATENATED MODULE: ./src/templates/product/ProductMedia/ProductMedia.jsx









function ProductMedia(param) {
    var product = param.product, enabledProductCarousel = param.enabledProductCarousel, enabledZoom = param.enabledZoom, selectedMedia = param.selectedMedia, selectedVariant = param.selectedVariant, soldOutQty = param.soldOutQty;
    var ref, ref1, ref2, ref3, ref4;
    var isMobileViewport = (0,hooks/* useMatchMedia */.ag)("(max-width: 767px)");
    var disabledProductCarousel = !enabledProductCarousel && !isMobileViewport;
    var ref5 = (0,react.useState)(null), swiper = ref5[0], setSwiper = ref5[1];
    var ref6 = (0,react.useState)(null), activeIndex = ref6[0], setActiveIndex = ref6[1];
    var ref7 = (0,react.useState)(false), swiperReady = ref7[0], setSwiperReady = ref7[1];
    var handleSwiperOnLoad = (0,react.useCallback)(function(index) {
        if (index !== 0) return;
        setSwiperReady(true);
    }, []);
    // Reset the active index when the selected color changes
    (0,react.useEffect)(function() {
        if (!swiper) return;
        setActiveIndex(0);
        swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(0);
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.selectedOptionsMap) === null || ref === void 0 ? void 0 : ref.Color,
        swiper
    ]);
    var firstMediaImage = selectedMedia === null || selectedMedia === void 0 ? void 0 : (ref1 = selectedMedia[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.preview) === null || ref2 === void 0 ? void 0 : ref2.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(enabledProductCarousel ? "grid grid-cols-1 justify-between gap-4 lg:grid-cols-[80px_calc(100%-6.4rem)] xl:gap-5" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main order-1 lg:order-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    // for a static/consistent aspect ratio, delete style below and add 'aspect-[var(--product-image-aspect-ratio)]' to className
                    style: {
                        aspectRatio: (firstMediaImage === null || firstMediaImage === void 0 ? void 0 : firstMediaImage.width) && (firstMediaImage === null || firstMediaImage === void 0 ? void 0 : firstMediaImage.height) ? firstMediaImage.width / firstMediaImage.height : "var(--product-image-aspect-ratio)"
                    },
                    children: [
                        disabledProductCarousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-2 gap-5",
                            children: selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.map(function(media) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "var(--product-image-aspect-ratio) only:md:w-[200%]",
                                    children: media.mediaContentType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo, {
                                        media: media
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                        alt: media.product.title,
                                        image: media.image,
                                        enabledZoom: enabledZoom,
                                        cursorStyle: enabledZoom ? "zoom-in" : "pointer",
                                        isMobileViewport: isMobileViewport
                                    })
                                }, media.id);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                    onSwiper: setSwiper,
                                    modules: [
                                        swiper_esm/* A11y */.s5,
                                        swiper_esm/* Pagination */.tl,
                                        swiper_esm/* Keyboard */.N1
                                    ],
                                    a11y: {
                                        enabled: true
                                    },
                                    onSlideChange: function(_swiper) {
                                        setActiveIndex(_swiper.realIndex);
                                    },
                                    slidesPerView: 1,
                                    centeredSlides: true,
                                    grabCursor: true,
                                    keyboard: {
                                        enabled: true,
                                        onlyInViewport: true
                                    },
                                    pagination: {
                                        el: ".swiper-pagination",
                                        clickable: true
                                    },
                                    role: "region",
                                    "aria-label": "".concat(product === null || product === void 0 ? void 0 : product.title, " Gallery Slider"),
                                    tabIndex: "0",
                                    children: [
                                        selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.map(function(media, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: media.mediaContentType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo, {
                                                    media: media,
                                                    onLoad: function() {
                                                        return handleSwiperOnLoad(index);
                                                    }
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                                    alt: media.product.title,
                                                    image: media.image,
                                                    onLoad: function() {
                                                        return handleSwiperOnLoad(index);
                                                    },
                                                    enabledZoom: enabledZoom,
                                                    cursorStyle: enabledZoom ? "zoom-in" : "grab",
                                                    isMobileViewport: isMobileViewport,
                                                    swiperInstance: swiper
                                                })
                                            }, media.id);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "active-bullet-black swiper-pagination bottom-[10px] flex w-full justify-center gap-2.5 md:hidden"
                                        })
                                    ]
                                }),
                                !swiperReady && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute inset-0 z-[1] h-full w-full max-md:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                        alt: product.title,
                                        image: firstMediaImage,
                                        priority: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-none absolute left-0 top-0 z-[1] p-5 xl:p-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Badges */.a9, {
                                isDraft: product.status === "DRAFT",
                                tags: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.product) === null || ref3 === void 0 ? void 0 : ref3.tags,
                                handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref4 = selectedVariant.product) === null || ref4 === void 0 ? void 0 : ref4.handle,
                                soldOutQty: soldOutQty,
                                isGiftCard: product === null || product === void 0 ? void 0 : product.isGiftCard
                            })
                        })
                    ]
                })
            }),
            !isMobileViewport & !disabledProductCarousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "scrollbar-hide relative order-2 hidden w-full overflow-x-auto md:block md:max-lg:pb-[calc((100%-5*8px)/6)] lg:order-1 lg:h-[calc(80px*5+12px*4)] xl:h-[calc(80px*6+12px*5)]",
                children: (selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaThumbnails, {
                    product: product,
                    activeIndex: activeIndex,
                    selectedMedia: selectedMedia,
                    setActiveIndex: setActiveIndex,
                    swiper: swiper
                })
            }) : null
        ]
    });
}
ProductMedia.displayName = "ProductMedia";

;// CONCATENATED MODULE: ./src/templates/product/ProductMedia/index.js


;// CONCATENATED MODULE: ./src/templates/product/useSelectedVariant.js







function useSelectedVariant(product) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var query = (0,next_router.useRouter)().query;
    var hasOneVariant = ((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1;
    var isNonGroupedProductWithMultiColors = !((ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : ref1.isTransformed) && ((ref2 = product.optionsMap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Color) === null || ref3 === void 0 ? void 0 : ref3.length) > 1;
    var productMedia = (0,react.useMemo)(function() {
        return product.media || // if shopify media transforms is off, shape image item similar to media item
        product.images.map(function(image) {
            return (0,utilities/* formatImageItemAsMediaItem */.v_)({
                image: image,
                product: product
            });
        });
    }, [
        product.id
    ]);
    var ref6 = (0,react.useState)(hasOneVariant ? (ref4 = product.variants) === null || ref4 === void 0 ? void 0 : ref4[0] : null), selectedVariant = ref6[0], setSelectedVariant = ref6[1];
    var ref7 = (0,react.useState)(hasOneVariant ? (ref5 = product.variants) === null || ref5 === void 0 ? void 0 : ref5[0].selectedOptionsMap : null), selectedOptions = ref7[0], setSelectedOptions = ref7[1];
    var ref8 = (0,react.useState)(isNonGroupedProductWithMultiColors ? null : productMedia), selectedMedia = ref8[0], setSelectedMedia = ref8[1];
    var ref9 = (0,react.useState)(true), needsSelection = ref9[0], setNeedsSelection = ref9[1];
    var selectedOptionsRef = (0,react.useRef)(selectedOptions);
    var ref10 = (0,react.useState)({
        "Color": true
    }), optionChanges = ref10[0], setOptionChanges = ref10[1];
    // const [optionChanges, setOptionChanges] = useState(getInitialOptionChanges);
    // set initial selected options on mount unless has one variant
    var setInitialSelectedOptionsOnProductMount = (0,react.useCallback)(function() {
        var params = new URLSearchParams(window.location.search);
        var queriedVariantId = params.get("variant");
        var queriedVariant = null;
        if (queriedVariantId) {
            var ref;
            queriedVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
                var legacyResourceId = param.legacyResourceId;
                return legacyResourceId === queriedVariantId;
            });
        }
        if (queriedVariant) {
            setSelectedOptions(queriedVariant.selectedOptionsMap);
        } else {
            var ref1;
            var firstAvailableVariant = (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1.find(function(param) {
                var availableForSale = param.availableForSale;
                return availableForSale;
            });
            if (firstAvailableVariant) {
                setSelectedOptions(firstAvailableVariant.selectedOptionsMap);
            } else {
                // If no variants are available, fall back to the first variant
                if (product.variants && product.variants.length > 0) {
                    setSelectedOptions(product.variants[0].selectedOptionsMap || null);
                } else {
                    setSelectedOptions(null);
                }
            }
        }
    }, [
        query.handle,
        product.id
    ]);
    // set selected variant from selected options unless has one variant
    var setSelectedVariantFromSelectedOptions = (0,react.useCallback)(function() {
        var ref;
        if (!selectedOptions) {
            setSelectedVariant(null);
            return;
        }
        var selectedVariantFromOptions = (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(selectedOptions, selectedOptionsMap);
        });
        setSelectedVariant(selectedVariantFromOptions || null);
    }, [
        query.handle,
        product.id,
        selectedOptions,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    // set variant url param on selected variant change unless has one variant
    var setVariantUrlParamOnSelectedVariantChange = (0,react.useCallback)(function() {
        var ref;
        if (((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 || !selectedVariant) return;
        var _location = window.location, origin = _location.origin, search = _location.search;
        var params = new URLSearchParams(search);
        var selectionValue = params.get("s");
        selectionValue && setNeedsSelection(selectionValue === "true");
        var variantFound = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = params.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                if (key === "variant") {
                    variantFound = true;
                    params.set("variant", selectedVariant.legacyResourceId); // Ensure the variant is updated
                    continue;
                }
                if (variantFound && key !== "s") {
                    var booleanValue = value === "true";
                    optionChanges[key] = booleanValue;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var updatedUrl = "".concat(origin, "/products/").concat(selectedVariant.product.handle, "?").concat(params);
        window.history.replaceState(window.history.state, "", updatedUrl);
    }, [
        query.handle,
        product.id,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    // set selected media on selected variant change
    var setSelectedMediaOnSelectedVariantChange = (0,react.useCallback)(function() {
        var ref;
        // filter media by color via possible alt tag if product is not grouped and has multiple colors
        if (((ref = product.optionsMap) === null || ref === void 0 ? void 0 : ref.Color) && selectedVariant) {
            var ref1, ref2, ref3;
            var colorOptions = (ref1 = product.optionsMap) === null || ref1 === void 0 ? void 0 : ref1.Color.map(function(color) {
                return color.toLowerCase();
            });
            var selectedColor = (ref2 = selectedVariant.selectedOptionsMap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Color) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase();
            setSelectedMedia(productMedia.filter(function(item) {
                var ref;
                var alt = (ref = item.alt) === null || ref === void 0 ? void 0 : ref.trim().toLowerCase();
                return alt === selectedColor || !colorOptions.includes(alt);
            }));
        } else {
            setSelectedMedia(productMedia);
        }
    }, [
        query.handle,
        product.id,
        productMedia,
        selectedMedia,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id, 
    ]);
    var updateOptionChanges = (0,react.useCallback)(function() {
        if (!needsSelection) {
            var newOptionChanges = Object.keys(selectedOptions || {}).reduce(function(acc, key) {
                acc[key] = true;
                return acc;
            }, {});
            setOptionChanges(newOptionChanges);
        } else {
            setOptionChanges({
                "Color": true
            });
        }
    }, [
        needsSelection,
        selectedOptions
    ]);
    var setRequiredOptions = (0,react.useCallback)(function() {
        if (!needsSelection) return;
        var prevSelectedOptions = selectedOptionsRef.current;
        var changes = (0,_object_spread/* default */.Z)({}, optionChanges);
        var hasOtherOptionsChanged = false;
        var isOptionChanged = function(key) {
            return prevSelectedOptions[key] !== selectedOptions[key];
        };
        var isNotColor = function(key) {
            return key !== "Color";
        };
        if (prevSelectedOptions && selectedOptions) {
            if (!needsSelection) return;
            var numberOfProperties = Object.keys(selectedOptions).length;
            var allKeys = new Set((0,_to_consumable_array/* default */.Z)(Object.keys(prevSelectedOptions)).concat((0,_to_consumable_array/* default */.Z)(Object.keys(selectedOptions))));
            if (numberOfProperties <= 2) {
                allKeys.forEach(function(key) {
                    if (isNotColor(key)) {
                        changes[key] = true;
                        hasOtherOptionsChanged = true;
                    }
                });
            } else {
                allKeys.forEach(function(key) {
                    if (isNotColor(key) && isOptionChanged(key)) {
                        changes[key] = true;
                    }
                });
                var requestedValues = Array.from(allKeys).reduce(function(acc, key) {
                    if (isNotColor(key)) {
                        acc[key] = true;
                    }
                    return acc;
                }, {});
                var changesWithoutColor = Object.keys(changes).reduce(function(acc, key) {
                    if (isNotColor(key)) {
                        acc[key] = changes[key];
                    }
                    return acc;
                }, {});
                var allChangesTrue = Object.keys(requestedValues).every(function(key) {
                    return changesWithoutColor[key];
                });
                if (allChangesTrue) {
                    hasOtherOptionsChanged = true;
                }
            }
        }
        setOptionChanges(changes);
        setNeedsSelection(!hasOtherOptionsChanged);
        selectedOptionsRef.current = selectedOptions;
    }, [
        selectedOptions,
        needsSelection
    ]);
    (0,react.useEffect)(function() {
        setInitialSelectedOptionsOnProductMount();
    }, [
        product.id
    ]);
    (0,react.useEffect)(function() {
        updateOptionChanges();
    }, [
        updateOptionChanges
    ]);
    (0,react.useEffect)(function() {
        setSelectedVariantFromSelectedOptions();
        setRequiredOptions();
    }, [
        selectedOptions
    ]);
    (0,react.useEffect)(function() {
        setVariantUrlParamOnSelectedVariantChange();
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    (0,react.useEffect)(function() {
        setSelectedMediaOnSelectedVariantChange();
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    return {
        selectedOptions: selectedOptions,
        selectedVariant: selectedVariant,
        setSelectedOptions: setSelectedOptions,
        selectedMedia: selectedMedia,
        needsSelection: needsSelection,
        setNeedsSelection: setNeedsSelection,
        optionChanges: optionChanges,
        setOptionChanges: setOptionChanges
    };
}

// EXTERNAL MODULE: ./src/snippets/ProductReviews/index.js + 1 modules
var ProductReviews = __webpack_require__(8920);
// EXTERNAL MODULE: ./src/snippets/ProductUpsellRecommendations/index.js + 1 modules
var ProductUpsellRecommendations = __webpack_require__(5592);
// EXTERNAL MODULE: ./src/snippets/ProductSimilarRecommendations/index.js + 1 modules
var ProductSimilarRecommendations = __webpack_require__(3312);
;// CONCATENATED MODULE: ./src/templates/product/ProductAddToCartBar.jsx



function ProductAddToCartBar(param) {
    var selectedVariant = param.selectedVariant, quantity = param.quantity, isMobileViewport = param.isMobileViewport, elementInView = param.elementInView, needsSelection = param.needsSelection, optionChanges = param.optionChanges, smoothScrollTo = param.smoothScrollTo, forceSoldOut = param.forceSoldOut;
    var selectionClasses = isMobileViewport && elementInView ? "h-0 !max-h-0" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed bottom-0 left-0 z-10 w-full max-w-full motion-reduce:transition-max-height duration-500 ease-in-out h-auto max-h-14 overflow-hidden ".concat(selectionClasses),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex-1 bg-white ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AddToCart */.o4, {
                isPdp: true,
                quantity: quantity,
                selectedVariant: selectedVariant,
                needsSelection: needsSelection,
                optionChanges: optionChanges,
                isMobileViewport: isMobileViewport,
                smoothScrollTo: smoothScrollTo,
                forceSoldOut: forceSoldOut
            })
        })
    });
}
ProductAddToCartBar.displayName = "ProductAddToCartBar";

;// CONCATENATED MODULE: ./src/templates/product/ProductBreadcrumbs.jsx






function ProductBreadcrumbs(param) {
    var breadcrumbs = param.breadcrumbs, product = param.product, enabledProductCarousel = param.enabledProductCarousel, setGroupedBreadcrumbs = param.setGroupedBreadcrumbs;
    var ref, ref1;
    var ref2 = breadcrumbs !== null && breadcrumbs !== void 0 ? breadcrumbs : {}, mens = ref2.mens, womens = ref2.womens;
    var productType = product === null || product === void 0 ? void 0 : product.productType;
    var ref3 = (0,react.useState)({
        parent: {
            title: "",
            handle: ""
        },
        main: {
            title: "",
            handle: ""
        },
        collection: {
            title: "",
            handle: ""
        }
    }), breadcrumbData = ref3[0], setBreadcrumbData = ref3[1];
    var findCollectionKey = function(mens, womens, value, keyType) {
        if (!mens && !womens || !value) return null;
        var searchCollections = function(obj) {
            for(var key in obj){
                var ref;
                var collections = (ref = obj[key]) === null || ref === void 0 ? void 0 : ref.collections;
                if (collections) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = collections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var item = _step.value;
                            var nestedValue = keyType.split(".").reduce(function(acc, part) {
                                return acc && acc[part];
                            }, item);
                            if (nestedValue === value) {
                                return key;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
            return null;
        };
        var mensKey = searchCollections(mens);
        if (mensKey) return {
            key: mensKey,
            type: "mens"
        };
        var womensKey = searchCollections(womens);
        if (womensKey) return {
            key: womensKey,
            type: "womens"
        };
        return null;
    };
    var findMainKey = function(mens, womens, value, keyType) {
        if (!mens && !womens || !value) return null;
        var searchCollections = function(obj) {
            for(var key in obj){
                if (obj[key] && obj[key].collection) {
                    var nestedValue = keyType.split(".").reduce(function(acc, part) {
                        return acc && acc[part];
                    }, obj[key].collection);
                    if (nestedValue === value) {
                        return key;
                    }
                }
            }
            return null;
        };
        var mensKey = searchCollections(mens);
        if (mensKey) return {
            key: mensKey,
            type: "mens"
        };
        var womensKey = searchCollections(womens);
        if (womensKey) return {
            key: womensKey,
            type: "womens"
        };
        return null;
    };
    var collectionKeyInfo = (0,react.useMemo)(function() {
        return findCollectionKey(mens, womens, breadcrumbData.collection.handle, "collection.url");
    }, [
        mens,
        womens,
        breadcrumbData.collection.handle
    ]);
    var isCollectionHandleInMensOrWomens = collectionKeyInfo !== null;
    var productTypeKeyInfo = (0,react.useMemo)(function() {
        return findCollectionKey(mens, womens, productType, "productType");
    }, [
        mens,
        womens,
        productType
    ]);
    var isProductTypeInMensOrWomens = productTypeKeyInfo !== null;
    var mainKeyInfo = (0,react.useMemo)(function() {
        return findMainKey(mens, womens, breadcrumbData.collection.handle, "url");
    }, [
        mens,
        womens,
        breadcrumbData.collection.handle
    ]);
    var isMainHandleInMensOrWomens = mainKeyInfo !== null;
    var handleParentCollection = function(parentKeyInfo, parentObj) {
        var ref, ref1;
        var parentCollection = (parentKeyInfo === null || parentKeyInfo === void 0 ? void 0 : parentKeyInfo.type) === "mens" ? mens === null || mens === void 0 ? void 0 : mens.collection : womens === null || womens === void 0 ? void 0 : womens.collection;
        if (parentCollection) {
            setBreadcrumbData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    parent: {
                        title: parentCollection.text,
                        handle: parentCollection.url
                    }
                });
            });
        } else {
            setBreadcrumbData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    parent: {
                        title: "Home",
                        handle: "/"
                    }
                });
            });
        }
        var parentKey = parentKeyInfo === null || parentKeyInfo === void 0 ? void 0 : parentKeyInfo.key;
        if (parentKey && ((ref = parentObj[parentKey]) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : ref1.url)) {
            setBreadcrumbData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    main: {
                        title: parentObj[parentKey].collection.text,
                        handle: parentObj[parentKey].collection.url
                    }
                });
            });
        } else {
            setBreadcrumbData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    main: {
                        title: "",
                        handle: ""
                    }
                });
            });
        }
    };
    (0,react.useEffect)(function() {
        var savedCollectionTitle = sessionStorage.getItem("savedCollectionTitle");
        var savedCollectionHandle = sessionStorage.getItem("savedCollectionHandle");
        var savedHistory = sessionStorage.getItem("savedHistory");
        if (savedCollectionTitle && savedCollectionHandle) {
            var groupedBreadcrumbs = {
                title: savedCollectionTitle,
                handle: savedCollectionHandle,
                path: savedHistory
            };
            setGroupedBreadcrumbs(groupedBreadcrumbs);
            setBreadcrumbData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    collection: {
                        title: savedCollectionTitle,
                        handle: "/collections/".concat(savedCollectionHandle)
                    }
                });
            });
            if (isCollectionHandleInMensOrWomens) {
                handleParentCollection(collectionKeyInfo, (collectionKeyInfo === null || collectionKeyInfo === void 0 ? void 0 : collectionKeyInfo.type) === "mens" ? mens : womens);
            } else {
                if (isMainHandleInMensOrWomens) {
                    var parentCollection = (mainKeyInfo === null || mainKeyInfo === void 0 ? void 0 : mainKeyInfo.type) === "mens" ? mens === null || mens === void 0 ? void 0 : mens.collection : womens === null || womens === void 0 ? void 0 : womens.collection;
                    setBreadcrumbData(function(prevData) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                            parent: {
                                title: parentCollection === null || parentCollection === void 0 ? void 0 : parentCollection.text,
                                handle: parentCollection === null || parentCollection === void 0 ? void 0 : parentCollection.url
                            }
                        });
                    });
                } else {
                    setBreadcrumbData(function(prevData) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                            parent: {
                                title: "Home",
                                handle: "/"
                            }
                        });
                    });
                }
            }
            // Clean the localStorage items
            setTimeout(function() {
                sessionStorage.removeItem("savedCollectionTitle");
                sessionStorage.removeItem("savedCollectionHandle");
            }, 0);
        } else {
            var groupedBreadcrumbs1 = {
                title: "",
                handle: "",
                path: savedHistory
            };
            setGroupedBreadcrumbs(groupedBreadcrumbs1);
            if (isProductTypeInMensOrWomens) {
                var ref, ref1;
                handleParentCollection(productTypeKeyInfo, (productTypeKeyInfo === null || productTypeKeyInfo === void 0 ? void 0 : productTypeKeyInfo.type) === "mens" ? mens : womens);
                var parentKey = productTypeKeyInfo === null || productTypeKeyInfo === void 0 ? void 0 : productTypeKeyInfo.key;
                var parentObj = (productTypeKeyInfo === null || productTypeKeyInfo === void 0 ? void 0 : productTypeKeyInfo.type) === "mens" ? mens : womens;
                var collectionItem = (ref = parentObj[parentKey]) === null || ref === void 0 ? void 0 : (ref1 = ref.collections) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                    return (item === null || item === void 0 ? void 0 : item.productType) === productType;
                });
                if (collectionItem) {
                    setBreadcrumbData(function(prevData) {
                        var ref, ref1;
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                            collection: {
                                title: collectionItem === null || collectionItem === void 0 ? void 0 : (ref = collectionItem.collection) === null || ref === void 0 ? void 0 : ref.text,
                                handle: collectionItem === null || collectionItem === void 0 ? void 0 : (ref1 = collectionItem.collection) === null || ref1 === void 0 ? void 0 : ref1.url
                            }
                        });
                    });
                } else {
                    setBreadcrumbData(function(prevData) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                            collection: {
                                title: "",
                                handle: ""
                            }
                        });
                    });
                }
            } else {
                setBreadcrumbData({
                    parent: {
                        title: "Home",
                        handle: "/"
                    },
                    main: {
                        title: "",
                        handle: ""
                    },
                    collection: {
                        title: "",
                        handle: ""
                    }
                });
            }
        }
    }, [
        isCollectionHandleInMensOrWomens,
        isProductTypeInMensOrWomens,
        isMainHandleInMensOrWomens,
        mens,
        womens
    ]);
    var breadcrumbAvailable = (breadcrumbData === null || breadcrumbData === void 0 ? void 0 : (ref = breadcrumbData.collection) === null || ref === void 0 ? void 0 : ref.handle) !== "" || (breadcrumbData === null || breadcrumbData === void 0 ? void 0 : (ref1 = breadcrumbData.main) === null || ref1 === void 0 ? void 0 : ref1.handle) !== "";
    return breadcrumbAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "shadow-hairline-b mb-[.5px] flex py-1 md:-mb-5 md:py-3.5 md:shadow-none xl:-mb-10 ".concat(enabledProductCarousel ? "px-contained max-md:px-5" : "px-5 md:px-5 xl:px-10"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-2.5 text-sm md:text-base ".concat(enabledProductCarousel ? "mx-auto w-full max-w-[var(--content-max-lg-width)]" : ""),
            children: [
                "parent",
                "main",
                "collection"
            ].map(function(key, index) {
                return breadcrumbData[key].title && breadcrumbData[key].handle && breadcrumbData[key].title !== "undefined" && breadcrumbData[key].handle !== "/collections/undefined" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                            className: "w-3 text-mediumGray",
                            src: "/svgs/chevron-right.svg#chevron-right",
                            alt: "Right Chevron Icon",
                            title: "Chevron",
                            viewBox: "0 0 24 24"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            "aria-label": breadcrumbData[key].title,
                            className: "text-sm text-mediumGray hover:text-primary",
                            href: breadcrumbData[key].handle,
                            children: breadcrumbData[key].title
                        })
                    ]
                }, key);
            })
        })
    });
}
ProductBreadcrumbs.displayName = "ProductBreadcrumbs";

;// CONCATENATED MODULE: ./src/templates/product/product.jsx


















function ProductTemplate(param) {
    var renderSections = param.renderSections, product = param.product, footerInView = param.footerInView;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41;
    var ref42 = useSelectedVariant(product), selectedVariant = ref42.selectedVariant, setSelectedOptions = ref42.setSelectedOptions, selectedOptions = ref42.selectedOptions, selectedMedia = ref42.selectedMedia, needsSelection = ref42.needsSelection, optionChanges = ref42.optionChanges, setOptionChanges = ref42.setOptionChanges;
    var settings = (0,dist.useSettings)();
    var sections = renderSections();
    var sendViewProductEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewProductEvent;
    var ref43 = (0,dist.useProductInventoryByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle,
        withInventory: false
    }), inventory = ref43.inventory, inventoryFetched = ref43.success;
    var ref44 = (0,react.useState)(), groupedBreadcrumbs = ref44[0], setGroupedBreadcrumbs = ref44[1];
    var isMobileViewport = (0,hooks/* useMatchMedia */.ag)("(max-width: 767px)");
    var ref45 = (0,react.useState)(1), quantity = ref45[0], setQuantity = ref45[1];
    var ref46 = (0,react.useState)(false), element1InView = ref46[0], setElement1InView = ref46[1];
    var ref47 = (0,react.useState)(false), element2InView = ref47[0], setElement2InView = ref47[1];
    var ref48 = (settings === null || settings === void 0 ? void 0 : (ref1 = settings.product) === null || ref1 === void 0 ? void 0 : ref1.options) || {}, enabledLowInventory = ref48.enabledLowInventory, lowInventoryQty = ref48.lowInventoryQty, lowInventoryMessage = ref48.lowInventoryMessage, enabledCustomSoldOutQty = ref48.enabledCustomSoldOutQty;
    var lowInventoryNotification = {
        enabled: enabledLowInventory,
        qty: lowInventoryQty,
        message: lowInventoryMessage
    };
    var soldOutQty = enabledCustomSoldOutQty ? settings === null || settings === void 0 ? void 0 : (ref2 = settings.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.options) === null || ref3 === void 0 ? void 0 : ref3.soldOutQty : 0;
    var isGiftCard = product === null || product === void 0 ? void 0 : product.isGiftCard;
    var isSoldOut = isGiftCard ? false : (inventory === null || inventory === void 0 ? void 0 : inventory.totalInventory) <= soldOutQty;
    var swatches = settings === null || settings === void 0 ? void 0 : (ref4 = settings.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colors) === null || ref5 === void 0 ? void 0 : ref5.swatches;
    var ref49 = (settings === null || settings === void 0 ? void 0 : (ref6 = settings.product) === null || ref6 === void 0 ? void 0 : ref6.options) || {}, disableGroupHistory = ref49.disableGroupHistory, enabledSoldOutColorSwatch = ref49.enabledSoldOutColorSwatch;
    var handleDecrement = (0,react.useCallback)(function() {
        if (quantity === 1) return;
        setQuantity(quantity - 1);
    }, [
        quantity
    ]);
    var handleIncrement = (0,react.useCallback)(function() {
        setQuantity(quantity + 1);
    }, [
        quantity
    ]);
    var smoothScrollTo = function(targetId) {
        var targetElement = document.getElementById(targetId);
        if (targetElement) {
            var offsetTop = targetElement.offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
            targetElement.setAttribute("tabindex", "-1"); // Make it focusable
            targetElement.focus();
        }
    };
    var ref50 = (0,react.useMemo)(function() {
        if (!sections) return {};
        return {
            productDetailAccordionsSection: sections.find(function(param) {
                var props = param.props;
                return (props === null || props === void 0 ? void 0 : props["data-comp"]) === "product-detail-accordions" && !(props === null || props === void 0 ? void 0 : props.hidden);
            }),
            belowTheFoldSections: sections.filter(function(param) {
                var props = param.props;
                return (props === null || props === void 0 ? void 0 : props["data-comp"]) !== "product-detail-accordions";
            })
        };
    }, [
        sections
    ]), productDetailAccordionsSection = ref50.productDetailAccordionsSection, belowTheFoldSections = ref50.belowTheFoldSections;
    var ref51 = (0,react_intersection_observer_dist/* useInView */.YD)({
        threshold: 0,
        triggerOnce: false,
        onChange: function(inView) {
            setElement1InView(inView);
        }
    }), refElement1 = ref51.ref;
    var ref52 = (0,react_intersection_observer_dist/* useInView */.YD)({
        threshold: 0,
        triggerOnce: false,
        onChange: function(inView) {
            setElement2InView(inView);
        }
    }), refElement2 = ref52.ref;
    (0,react.useEffect)(function() {
        if (!selectedVariant) return;
        sendViewProductEvent({
            product: product,
            selectedVariant: selectedVariant,
            footerInView: footerInView
        });
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref7 = selectedVariant.product) === null || ref7 === void 0 ? void 0 : ref7.handle,
        sendViewProductEvent,
        footerInView
    ]);
    var stickyPromobar = (settings === null || settings === void 0 ? void 0 : (ref8 = settings.header) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.promobar) === null || ref9 === void 0 ? void 0 : ref9.enabled) && !(settings === null || settings === void 0 ? void 0 : (ref10 = settings.header) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.promobar) === null || ref11 === void 0 ? void 0 : ref11.autohide);
    var stickyTopClass = stickyPromobar ? "md:top-[calc(var(--header-height)+var(--promobar-height)+2.5rem)] lg:top-[calc(var(--header-height)+var(--promobar-height)+2.5rem)] xl:top-[calc(var(--header-height)+var(--promobar-height)+3rem)]" : "md:top-[calc(var(--header-height))] lg:top-[calc(var(--header-height)+2.5rem)] xl:top-[calc(var(--header-height)+2.5rem)]";
    var enabledProductCarousel = settings === null || settings === void 0 ? void 0 : (ref12 = settings.product) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.productCarousel) === null || ref13 === void 0 ? void 0 : ref13.enabled;
    var enabledZoom = settings === null || settings === void 0 ? void 0 : (ref14 = settings.product) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.productCarousel) === null || ref15 === void 0 ? void 0 : ref15.enableZoom;
    var enabledQuantitySelector = settings === null || settings === void 0 ? void 0 : (ref16 = settings.product) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.quantitySelector) === null || ref17 === void 0 ? void 0 : ref17.enabled;
    var productTitleMobilePlacement = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref18 = settings.product) === null || ref18 === void 0 ? void 0 : ref18.details).productTitleMobilePlacement;
    var ref53 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.product), breadcrumbs = ref53.breadcrumbs, upsellProducts = ref53.upsellProducts, similarProducts = ref53.similarProducts;
    var enabledReviewWidget = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref19 = settings.product) === null || ref19 === void 0 ? void 0 : ref19.reviews).enabledReviewWidget;
    var heading = product === null || product === void 0 ? void 0 : product.title;
    var enabledsizeGuide = product.metafields && product.metafields.find(function(metafield) {
        return metafield.key === "size_guide" && metafield.value === "true";
    });
    var note = (ref20 = product.metafields) === null || ref20 === void 0 ? void 0 : ref20.find(function(metafield) {
        return metafield.key === "note" && metafield.value.trim() !== "";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: heading && "Rhoback" ? "".concat(heading, " | ").concat("Rhoback") : heading || "Rhoback" || 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "oke:subscriber_id",
                        content: "2ff2e00e-dfb3-49a9-adab-140f21da02c7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://cdn-static.okendo.io/reviews-widget-plus/js/okendo-reviews.js",
                strategy: "afterInteractive",
                onLoad: function() {
                    return console.log("Okendo script loaded successfully");
                },
                onError: function(e) {
                    return console.error("Error loading Okendo script:", e);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.enabled) && !isGiftCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBreadcrumbs, {
                        breadcrumbs: breadcrumbs,
                        product: product,
                        setGroupedBreadcrumbs: setGroupedBreadcrumbs,
                        enabledProductCarousel: enabledProductCarousel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-contained py-contained ".concat(productTitleMobilePlacement === "underImage" ? "max-md:!pt-0" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto max-md:flex max-md:flex-col md:grid md:grid-cols-12 md:grid-rows-1 md:gap-5 2xl:gap-10 ".concat(enabledProductCarousel ? "max-w-[var(--content-max-lg-width)]" : "max-w-[var(--content-max-xl-width)]"),
                            children: [
                                isMobileViewport && productTitleMobilePlacement === "aboveImage" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader, {
                                    isMobile: true,
                                    isMobileViewport: isMobileViewport,
                                    product: product,
                                    isGiftCard: isGiftCard,
                                    selectedVariant: selectedVariant,
                                    note: note,
                                    headerExtraClasses: "pb-5"
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-12 max-md:-mx-5 ".concat(enabledProductCarousel ? "md:col-span-6 2xl:col-span-7" : "md:col-span-7"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:sticky ".concat(stickyTopClass, " overflow-hidden"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMedia, {
                                                enabledProductCarousel: enabledProductCarousel,
                                                enabledZoom: enabledZoom,
                                                product: product,
                                                selectedMedia: selectedMedia,
                                                selectedVariant: selectedVariant,
                                                soldOutQty: soldOutQty
                                            }),
                                            (upsellProducts === null || upsellProducts === void 0 ? void 0 : upsellProducts.upsellVisibility) === "underProductGallery" && !isMobileViewport && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full mt-10",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductUpsellRecommendations/* ProductUpsellRecommendations */.d, {
                                                    legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId,
                                                    upsellProducts: upsellProducts
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-12 ".concat(enabledProductCarousel ? "md:col-span-6 md:col-start-7 2xl:col-span-5 2xl:col-start-8" : "md:col-span-5 md:col-start-8"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:sticky ".concat(stickyTopClass),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col bg-white gap-y-2.5 md:gap-y-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader, {
                                                        isMobileViewport: isMobileViewport,
                                                        product: product,
                                                        isGiftCard: isGiftCard,
                                                        selectedVariant: selectedVariant,
                                                        productTitleMobilePlacement: productTitleMobilePlacement,
                                                        smoothScrollTo: smoothScrollTo,
                                                        note: note,
                                                        headerExtraClasses: "max-md:pt-5"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                                                        isMobileViewport: isMobileViewport,
                                                        enabledQuantitySelector: enabledQuantitySelector,
                                                        enabledTrustBuilders: settings === null || settings === void 0 ? void 0 : (ref21 = settings.product) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.trustBuilders) === null || ref22 === void 0 ? void 0 : ref22.enabled,
                                                        product: product,
                                                        productDetailAccordionsSection: productDetailAccordionsSection,
                                                        selectedOptions: selectedOptions,
                                                        selectedVariant: selectedVariant,
                                                        setSelectedOptions: setSelectedOptions,
                                                        isGiftCard: isGiftCard,
                                                        inventory: inventory,
                                                        inventoryFetched: inventoryFetched,
                                                        quantity: quantity,
                                                        handleDecrement: handleDecrement,
                                                        handleIncrement: handleIncrement,
                                                        refElement: refElement1,
                                                        lowInventoryNotification: lowInventoryNotification,
                                                        enabledsizeGuide: enabledsizeGuide,
                                                        sizeGuides: settings === null || settings === void 0 ? void 0 : (ref23 = settings.product) === null || ref23 === void 0 ? void 0 : ref23.sizeGuides,
                                                        swatches: swatches,
                                                        disableGroupHistory: disableGroupHistory,
                                                        enabledSoldOutColorSwatch: enabledSoldOutColorSwatch,
                                                        isSoldOut: isSoldOut,
                                                        soldOutQty: soldOutQty,
                                                        enabledGroupTabs: settings === null || settings === void 0 ? void 0 : (ref24 = settings.product) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.options) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.groupTabs) === null || ref26 === void 0 ? void 0 : ref26.enabledGroupTabs,
                                                        enabledGroupTabsLink: settings === null || settings === void 0 ? void 0 : (ref27 = settings.product) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.options) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.groupTabs) === null || ref29 === void 0 ? void 0 : ref29.enabledGroupTabsLink,
                                                        productTypeForGroupTabs: settings === null || settings === void 0 ? void 0 : (ref30 = settings.product) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.options) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.groupTabs) === null || ref32 === void 0 ? void 0 : ref32.productTypeForGroupTabs,
                                                        enabledGroupOptions: settings === null || settings === void 0 ? void 0 : (ref33 = settings.product) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.options) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.groupOptions) === null || ref35 === void 0 ? void 0 : ref35.enabledGroupOptions,
                                                        enabledGroupOptionsLink: settings === null || settings === void 0 ? void 0 : (ref36 = settings.product) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.options) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.groupOptions) === null || ref38 === void 0 ? void 0 : ref38.enabledGroupOptionsLink,
                                                        productTypeForGroupOptions: settings === null || settings === void 0 ? void 0 : (ref39 = settings.product) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.options) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.groupOptions) === null || ref41 === void 0 ? void 0 : ref41.productTypeForGroupOptions,
                                                        needsSelection: needsSelection,
                                                        optionChanges: optionChanges,
                                                        setOptionChanges: setOptionChanges,
                                                        groupedBreadcrumbs: groupedBreadcrumbs
                                                    })
                                                ]
                                            }),
                                            ((upsellProducts === null || upsellProducts === void 0 ? void 0 : upsellProducts.upsellVisibility) === "underProductDetails" || (upsellProducts === null || upsellProducts === void 0 ? void 0 : upsellProducts.upsellVisibility) === "underProductGallery" && isMobileViewport) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductUpsellRecommendations/* ProductUpsellRecommendations */.d, {
                                                legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId,
                                                upsellProducts: upsellProducts
                                            })
                                        ]
                                    })
                                }),
                                enabledReviewWidget ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews/* ProductReviews */.v, {
                                        productId: product === null || product === void 0 ? void 0 : product.legacyResourceId,
                                        stickyTopClass: stickyTopClass
                                    })
                                }) : null
                            ]
                        })
                    }),
                    belowTheFoldSections || null,
                    isMobileViewport && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAddToCartBar, {
                        selectedVariant: selectedVariant,
                        quantity: quantity,
                        isMobileViewport: isMobileViewport,
                        elementInView: element1InView || element2InView || footerInView,
                        optionChanges: optionChanges,
                        needsSelection: needsSelection,
                        smoothScrollTo: smoothScrollTo,
                        forceSoldOut: isSoldOut
                    }),
                    (similarProducts === null || similarProducts === void 0 ? void 0 : similarProducts.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: refElement2,
                        className: "col-span-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSimilarRecommendations/* ProductSimilarRecommendations */.P, {
                                legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId,
                                similarProducts: similarProducts
                            })
                        })
                    })
                ]
            })
        ]
    });
}
ProductTemplate.displayName = "ProductTemplate";

;// CONCATENATED MODULE: ./src/templates/product/index.js

/* harmony default export */ var templates_product = (ProductTemplate);

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(3183);
;// CONCATENATED MODULE: ./src/pages/products/[handle].jsx
/* eslint-disable import/no-unresolved */ 









function DraftBadge() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        "data-comp": "DraftProductBadge",
        // eslint-disable-next-line react/no-unknown-property
        sx: {
            position: "fixed",
            right: 0,
            top: 175,
            transform: "rotate(-90deg)",
            transformOrigin: "bottom right",
            backgroundColor: "#433d51",
            color: "#FFF",
            px: "20px",
            py: "10px",
            fontSize: "14px",
            letterSpacing: "4px",
            fontWeight: 200
        },
        children: "DRAFT"
    });
}
var __N_SSG = true;
function Product(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var router = (0,next_router.useRouter)();
    var settingProduct = (0,react.useRef)(false);
    var product = props.product;
    var ref = (0,_sliced_to_array/* default */.Z)(dist.store.recoil.useRecoilState(dist.store.state.product), 2), recoilProduct = ref[0], setProduct = ref[1];
    var hasQueryParam = router.asPath.includes("?");
    var nextQueryParamReady = Object.keys(router.query).length > 1;
    var handlesMatch = (product === null || product === void 0 ? void 0 : product.handle) === (recoilProduct === null || recoilProduct === void 0 ? void 0 : recoilProduct.handle);
    (0,react.useEffect)(function() {
        if (!handlesMatch) {
            // load the product onto the recoil state
            settingProduct.current = true;
            setProduct(product);
        } else {
            settingProduct.current = false;
        }
        return function() {
            if (hasQueryParam && !nextQueryParamReady) {
                // if we are processing query params
                return;
            }
            if (!settingProduct.current) {
                // unload the product onto the recoil state
                setProduct(null);
            }
        };
    }, [
        handlesMatch
    ]);
    var productPage = props.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageHead */.yG, {
            page: productPage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(templates_product, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        product: product,
                        renderSections: renderSections
                    })),
                    (product === null || product === void 0 ? void 0 : product.publishedAt) === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DraftBadge, {}) : null
                ]
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [781,774,888,179], function() { return __webpack_exec__(8718); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);